(function () {
  'use strict';

  const STORAGE_KEY = 'creodise_customizer_state_v16';
  let cdMasterFile = null;
  const moneyFormat = (window.theme && window.theme.money_format) || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    const value = (Number(cents || 0) / 100).toFixed(2);
    return '$' + value;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, Number(value || 0)));
  }

  function readState() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function writeState(next) {
    try {
      const current = readState();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, current, next)));
    } catch (e) {}
  }

  function fileToDataUrl(file) {
    return new Promise(function (resolve, reject) {
      const reader = new FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function initGenericBuilder(section) {
    const input = section.querySelector('[data-cd-master-upload]');
    const preview = section.querySelector('[data-cd-master-preview]');
    const cards = section.querySelectorAll('[data-cd-product-card]');
    const panels = section.querySelectorAll('[data-cd-builder-panel]');
    const startButton = section.querySelector('[data-cd-start-builder]');
    const workspace = section.querySelector('[data-cd-builder-workspace]');
    const modeButtons = section.querySelectorAll('[data-cd-photo-mode]');
    const productChooser = section.querySelector('[data-cd-product-chooser]');
    if (!input) return;

    if (startButton && workspace) {
      startButton.addEventListener('click', function () {
        const revealTargets = document.querySelectorAll('[data-cd-reveal-after-start]');
        section.classList.add('is-started');
        revealTargets.forEach(function (target) {
          target.classList.add('is-open');
          target.setAttribute('aria-hidden', 'false');
        });
        setTimeout(function () {
          workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 40);
      });
    }

    function setPreview(src) {
      if (!preview) return;
      preview.innerHTML = '';
      const img = new Image();
      img.src = src;
      img.alt = 'Uploaded photo preview';
      img.className = 'cd-master-preview__image';
      preview.classList.add('has-photo');
      preview.appendChild(img);
    }

    input.addEventListener('change', function () {
      const file = input.files && input.files[0];
      if (!file) return;
      fileToDataUrl(file).then(function (dataUrl) {
        cdMasterFile = file;
        writeState({ originalPreviewDataUrl: dataUrl, aiEnabled: false, aiImageUrl: '', editedImageUrl: '' });
        setPreview(dataUrl);
        document.dispatchEvent(new CustomEvent('creodise:master-photo', { detail: { dataUrl: dataUrl, file: file, fileInput: input } }));

        // v62: Reduce friction. After a photo is uploaded, keep the Original option
        // visually selected and move directly to product selection. The AI option
        // remains visible as a coming-soon path, but it is not required to click
        // Original before choosing a product.
        modeButtons.forEach(function (item) { item.classList.remove('is-active'); });
        const originalMode = section.querySelector('[data-cd-photo-mode="original"]');
        if (originalMode) originalMode.classList.add('is-active');
        writeState({ photoMode: 'original', aiEnabled: false });
        revealProductChooser();
      });
    });

    function revealProductChooser() {
      if (!productChooser) return;
      productChooser.classList.add('is-open');
      productChooser.setAttribute('aria-hidden', 'false');
      setTimeout(function () {
        productChooser.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }

    modeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const mode = button.getAttribute('data-cd-photo-mode');
        if (!mode || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        modeButtons.forEach(function (item) { item.classList.remove('is-active'); });
        button.classList.add('is-active');
        writeState({ photoMode: mode, aiEnabled: mode === 'ai' });
        if (mode === 'original') revealProductChooser();
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        const type = card.getAttribute('data-cd-product-card');
        if (!type || card.getAttribute('aria-disabled') === 'true') return;
        cards.forEach(function (item) { item.classList.remove('is-active'); });
        card.classList.add('is-active');
        panels.forEach(function (panel) {
          const active = panel.getAttribute('data-cd-builder-panel') === type;
          panel.classList.toggle('is-active', active);
          if (active) {
            setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80);
          }
        });
        writeState({ selectedProductType: type });
        const state = readState();
        if (state.originalPreviewDataUrl) {
          if (type === 'puzzle') {
            document.dispatchEvent(new CustomEvent('creodise:puzzle-photo-url', { detail: { dataUrl: state.originalPreviewDataUrl } }));
          }
          if (type === 'glass') {
            document.dispatchEvent(new CustomEvent('creodise:glass-photo-url', { detail: { dataUrl: state.originalPreviewDataUrl } }));
          }
          if (type === 'crystal') {
            document.dispatchEvent(new CustomEvent('creodise:crystal-photo-url', { detail: { dataUrl: state.originalPreviewDataUrl } }));
          }
          if (type === 'song-plaque') {
            document.dispatchEvent(new CustomEvent('creodise:song-photo-url', { detail: { dataUrl: state.originalPreviewDataUrl } }));
          }
          if (type === 'record-plaque') {
            document.dispatchEvent(new CustomEvent('creodise:record-photo-url', { detail: { dataUrl: state.originalPreviewDataUrl } }));
          }
        }
      });
    });
  }

  function inferPieceCount(title) {
    const text = String(title || '').toLowerCase();
    const known = text.match(/\b(99|100|500|1000)\b/);
    if (known) return Number(known[1]);

    const allNumbers = text.match(/\d+/g) || [];
    for (let i = 0; i < allNumbers.length; i++) {
      const n = Number(allNumbers[i]);
      if (n >= 50 && n <= 2000) return n;
    }
    return 100;
  }

  function gridForPieces(pieceCount) {
    if (pieceCount >= 900) return { pieces: 1000, cols: 40, rows: 25 };
    if (pieceCount >= 400) return { pieces: 500, cols: 25, rows: 20 };
    if (pieceCount === 99) return { pieces: 99, cols: 11, rows: 9 };
    if (pieceCount >= 95 && pieceCount <= 120) return { pieces: pieceCount, cols: 10, rows: 10 };
    return { pieces: pieceCount, cols: Math.max(6, Math.round(Math.sqrt(pieceCount * 1.4))), rows: Math.max(5, Math.round(Math.sqrt(pieceCount / 1.4))) };
  }

  function inferAspect(title) {
    const text = String(title || '').replace(/×/g, 'x');
    const match = text.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    if (!match) return 19 / 13.5;
    const a = Number(match[1]);
    const b = Number(match[2]);
    if (!a || !b) return 19 / 13.5;
    return Math.max(a, b) / Math.min(a, b);
  }

  function buildPuzzlePath(cols, rows, width, height) {
    const cellW = width / cols;
    const cellH = height / rows;
    const bulge = Math.min(cellW, cellH) * 0.28;
    const vr = cellH * 0.18;
    const hr = cellW * 0.18;
    let d = '';

    for (let i = 1; i < cols; i++) {
      const x = i * cellW;
      for (let j = 0; j < rows; j++) {
        const y1 = j * cellH;
        const y2 = (j + 1) * cellH;
        const mid = (y1 + y2) / 2;
        const dir = ((i + j) % 2 === 0) ? 1 : -1;
        d += 'M ' + x + ' ' + y1 + ' L ' + x + ' ' + (mid - vr) +
          ' C ' + (x + dir * bulge) + ' ' + (mid - vr) + ', ' +
          (x + dir * bulge) + ' ' + (mid + vr) + ', ' + x + ' ' + (mid + vr) +
          ' L ' + x + ' ' + y2 + ' ';
      }
    }

    for (let j = 1; j < rows; j++) {
      const y = j * cellH;
      for (let i = 0; i < cols; i++) {
        const x1 = i * cellW;
        const x2 = (i + 1) * cellW;
        const mid = (x1 + x2) / 2;
        const dir = ((i + j) % 2 === 0) ? -1 : 1;
        d += 'M ' + x1 + ' ' + y + ' L ' + (mid - hr) + ' ' + y +
          ' C ' + (mid - hr) + ' ' + (y + dir * bulge) + ', ' +
          (mid + hr) + ' ' + (y + dir * bulge) + ', ' + (mid + hr) + ' ' + y +
          ' L ' + x2 + ' ' + y + ' ';
      }
    }
    return d;
  }

  function buildPuzzleSvg(cols, rows, aspect) {
    const width = 1000;
    const safeAspect = Number(aspect || (19 / 13.5));
    const height = Math.round(width / safeAspect);
    const d = buildPuzzlePath(cols, rows, width, height);
    const pieces = cols * rows;
    const dense = pieces >= 500;
    const lineWidth = dense ? 0.85 : 1.45;
    const shadowWidth = dense ? 1.75 : 2.65;
    const opacity = pieces >= 900 ? 0.72 : pieces >= 500 ? 0.82 : 0.94;

    return '' +
      '<svg class="cd-puzzle-svg" viewBox="0 0 ' + width + ' ' + height + '" preserveAspectRatio="none" aria-hidden="true" style="opacity:' + opacity + '">' +
      '<path class="cd-puzzle-svg__shadow" d="' + d + '" style="stroke-width:' + shadowWidth + '" />' +
      '<path class="cd-puzzle-svg__line" d="' + d + '" style="stroke-width:' + lineWidth + '" />' +
      '<rect class="cd-puzzle-svg__edge" x="1.5" y="1.5" width="997" height="' + (height - 3) + '" rx="10" />' +
      '</svg>';
  }

  function drawPuzzlePathOnCanvas(ctx, cols, rows, width, height) {
    const cellW = width / cols;
    const cellH = height / rows;
    const bulge = Math.min(cellW, cellH) * 0.28;
    const vr = cellH * 0.18;
    const hr = cellW * 0.18;

    function verticalLine(i) {
      const x = i * cellW;
      for (let j = 0; j < rows; j++) {
        const y1 = j * cellH;
        const y2 = (j + 1) * cellH;
        const mid = (y1 + y2) / 2;
        const dir = ((i + j) % 2 === 0) ? 1 : -1;
        ctx.moveTo(x, y1);
        ctx.lineTo(x, mid - vr);
        ctx.bezierCurveTo(x + dir * bulge, mid - vr, x + dir * bulge, mid + vr, x, mid + vr);
        ctx.lineTo(x, y2);
      }
    }

    function horizontalLine(j) {
      const y = j * cellH;
      for (let i = 0; i < cols; i++) {
        const x1 = i * cellW;
        const x2 = (i + 1) * cellW;
        const mid = (x1 + x2) / 2;
        const dir = ((i + j) % 2 === 0) ? -1 : 1;
        ctx.moveTo(x1, y);
        ctx.lineTo(mid - hr, y);
        ctx.bezierCurveTo(mid - hr, y + dir * bulge, mid + hr, y + dir * bulge, mid + hr, y);
        ctx.lineTo(x2, y);
      }
    }

    ctx.beginPath();
    for (let i = 1; i < cols; i++) verticalLine(i);
    for (let j = 1; j < rows; j++) horizontalLine(j);
    ctx.stroke();
  }

  function initPuzzleBuilder(root) {
    const configEl = root.querySelector('[data-cd-puzzle-config]');
    if (!configEl) return;

    let config = {};
    try { config = JSON.parse(configEl.textContent || '{}'); }
    catch (e) { config = {}; }

    const form = root.querySelector('[data-cd-puzzle-form]');
    const fileInput = root.querySelector('[data-cd-puzzle-upload]');
    const previewFileInput = root.querySelector('[data-cd-preview-upload]');
    const editedFileInput = root.querySelector('[data-cd-edited-upload]');
    const previewStage = root.querySelector('[data-cd-puzzle-stage]');
    const previewImage = root.querySelector('[data-cd-puzzle-image]');
    const overlay = root.querySelector('[data-cd-puzzle-overlay]');
    const gridTexts = root.querySelectorAll('[data-cd-grid-text]');
    const pieceGridInput = root.querySelector('[data-cd-piece-grid]');
    const pieceCountInput = root.querySelector('[data-cd-piece-count]');
    const addButton = root.querySelector('[data-cd-add-to-cart]');
    const variantRadios = root.querySelectorAll('[data-cd-variant-radio]');
    const variantInput = root.querySelector('[data-cd-variant-input]');
    const variantTitle = root.querySelector('[data-cd-selected-variant-title]');
    const variantPrice = root.querySelector('[data-cd-selected-variant-price]');
    const uploadLabel = root.querySelector('[data-cd-upload-label]');
    const inputs = {
      zoom: root.querySelector('[data-cd-control="zoom"]'),
      x: root.querySelector('[data-cd-control="x"]'),
      y: root.querySelector('[data-cd-control="y"]'),
      rotate: root.querySelector('[data-cd-control="rotate"]'),
      brightness: root.querySelector('[data-cd-control="brightness"]'),
      contrast: root.querySelector('[data-cd-control="contrast"]'),
      saturation: root.querySelector('[data-cd-control="saturation"]'),
      grayscale: root.querySelector('[data-cd-control="grayscale"]')
    };
    const valueLabels = {
      zoom: root.querySelector('[data-cd-value="zoom"]'),
      x: root.querySelector('[data-cd-value="x"]'),
      y: root.querySelector('[data-cd-value="y"]'),
      rotate: root.querySelector('[data-cd-value="rotate"]'),
      brightness: root.querySelector('[data-cd-value="brightness"]'),
      contrast: root.querySelector('[data-cd-value="contrast"]'),
      saturation: root.querySelector('[data-cd-value="saturation"]'),
      grayscale: root.querySelector('[data-cd-value="grayscale"]')
    };
    const cropInput = root.querySelector('[data-cd-crop-data]');
    const adjustmentsInput = root.querySelector('[data-cd-adjustments]');
    const previewNoteInput = root.querySelector('[data-cd-preview-note]');
    const selectedProductInput = root.querySelector('[data-cd-selected-product]');
    const status = root.querySelector('[data-cd-status]');
    const publicOptionInput = root.querySelector('[data-cd-public-option]');
    const publicStyleInput = root.querySelector('[data-cd-public-style]');
    const actionButtons = root.querySelectorAll('[data-cd-action]');
    const filterPresetButtons = root.querySelectorAll('[data-cd-filter-preset]');
    const pieceBadges = root.querySelectorAll('[data-cd-piece-badge]');
    const rightsCheckbox = root.querySelector('[data-cd-copyright-checkbox]');

    let imageLoaded = false;
    let selectedFile = null;
    let controls = { zoom: 1, x: 0, y: 0, rotate: 0, brightness: 100, contrast: 100, saturation: 100, grayscale: 0 };
    let currentGrid = { pieces: 100, cols: 10, rows: 10, aspect: 19 / 13.5, title: '' };
    let dragging = false;
    let dragStart = { x: 0, y: 0, cx: 0, cy: 0 };

    function syncInputs() {
      Object.keys(inputs).forEach(function (key) {
        const input = inputs[key];
        if (input) input.value = String(controls[key]);
      });
      if (valueLabels.zoom) valueLabels.zoom.textContent = Math.round(Number(controls.zoom) * 100) + '%';
      if (valueLabels.x) valueLabels.x.textContent = Math.round(Number(controls.x));
      if (valueLabels.y) valueLabels.y.textContent = Math.round(Number(controls.y));
      if (valueLabels.rotate) valueLabels.rotate.textContent = Math.round(Number(controls.rotate)) + '°';
      if (valueLabels.brightness) valueLabels.brightness.textContent = Math.round(Number(controls.brightness)) + '%';
      if (valueLabels.contrast) valueLabels.contrast.textContent = Math.round(Number(controls.contrast)) + '%';
      if (valueLabels.saturation) valueLabels.saturation.textContent = Math.round(Number(controls.saturation)) + '%';
      if (valueLabels.grayscale) valueLabels.grayscale.textContent = Math.round(Number(controls.grayscale)) + '%';
    }

    function currentFilter() {
      return 'brightness(' + Number(controls.brightness) + '%) contrast(' + Number(controls.contrast) + '%) saturate(' + Number(controls.saturation) + '%) grayscale(' + Number(controls.grayscale) + '%)';
    }

    function hasOrderFile() {
      return !!(selectedFile || (fileInput && fileInput.files && fileInput.files.length));
    }

    function syncSelectedFileToInput() {
      if (!fileInput || !selectedFile || (fileInput.files && fileInput.files.length)) return;
      if (window.DataTransfer) {
        const dt = new DataTransfer();
        dt.items.add(selectedFile);
        fileInput.files = dt.files;
      }
    }

    function updateAddButton() {
      if (!addButton) return;
      const hasVariant = variantInput && variantInput.value;
      const hasRights = !rightsCheckbox || rightsCheckbox.checked;
      const ready = imageLoaded && hasVariant && hasOrderFile() && hasRights && config.productAvailable !== false;
      addButton.disabled = !ready;
      if (status) {
        if (!imageLoaded) status.textContent = 'Upload a photo to begin.';
        else if (!hasOrderFile()) status.textContent = 'Photo preview is visible. Please upload/attach the original file in this step before adding to cart.';
        else if (!hasVariant) status.textContent = 'Choose a puzzle option to continue.';
        else if (!hasRights) status.textContent = 'Confirm image rights before adding to cart.';
        else if (config.productAvailable === false) status.textContent = 'Puzzle options are not connected yet.';
        else status.textContent = 'Ready. Original photo and edited production image will be sent with the order.';
      }
    }

    function updatePieceBadges() {
      variantRadios.forEach(function (radio) {
        const card = radio.closest('.cd-variant-card');
        if (!card) return;
        const badge = card.querySelector('[data-cd-piece-badge]');
        if (!badge) return;
        const pieces = Number(radio.getAttribute('data-piece-count') || inferPieceCount(radio.getAttribute('data-title') || ''));
        badge.textContent = pieces + ' pc';
      });
    }

    function updateStageAspect() {
      if (!previewStage) return;
      const aspect = Number(currentGrid.aspect || (19 / 13.5));
      previewStage.style.setProperty('--cd-puzzle-aspect', String(aspect));
      previewStage.style.aspectRatio = aspect + ' / 1';
      previewStage.setAttribute('data-cd-piece-count', String(currentGrid.pieces));
    }

    function updatePuzzleOverlay() {
      if (!overlay) return;
      updateStageAspect();
      overlay.innerHTML = buildPuzzleSvg(currentGrid.cols, currentGrid.rows, currentGrid.aspect);
      const label = currentGrid.pieces + ' pieces • real size ratio preview ' + currentGrid.cols + ' × ' + currentGrid.rows;
      gridTexts.forEach(function (item) { item.textContent = label; });
      if (pieceGridInput) pieceGridInput.value = label;
      if (pieceCountInput) pieceCountInput.value = String(currentGrid.pieces);
      if (publicOptionInput) publicOptionInput.value = (currentGrid.title || (currentGrid.pieces + ' pieces'));

    }

    function updateGridFromRadio(radio) {
      const rawTitle = radio ? (radio.getAttribute('data-title') || '') : '';
      const displayTitle = radio ? (radio.getAttribute('data-display-title') || rawTitle) : rawTitle;
      const pieceCount = Number(radio && radio.getAttribute('data-piece-count')) || inferPieceCount(rawTitle);
      const explicitCols = Number(radio && radio.getAttribute('data-cols'));
      const explicitRows = Number(radio && radio.getAttribute('data-rows'));
      const explicitAspect = Number(radio && radio.getAttribute('data-aspect'));
      const baseGrid = gridForPieces(pieceCount);
      const grid = {
        pieces: pieceCount,
        cols: explicitCols || baseGrid.cols,
        rows: explicitRows || baseGrid.rows
      };
      currentGrid = Object.assign({}, grid, {
        aspect: explicitAspect || inferAspect(rawTitle),
        title: displayTitle || rawTitle || ''
      });
      updatePuzzleOverlay();
      updateCropData();
    }

    function updateCropData() {
      const payload = {
        version: 'creodise-builder-mvp-v52',
        product_type: 'custom_photo_puzzle',
        ai_ready: true,
        ai_visible_initially: false,
        source: 'original_photo',
        selected_variant_title: currentGrid.title || '',
        preview_piece_count: Number(currentGrid.pieces),
        preview_grid_columns: Number(currentGrid.cols),
        preview_grid_rows: Number(currentGrid.rows),
        preview_aspect_ratio: Number(Number(currentGrid.aspect).toFixed(4)),
        zoom: Number(Number(controls.zoom).toFixed(2)),
        x: Math.round(Number(controls.x)),
        y: Math.round(Number(controls.y)),
        rotate: Math.round(Number(controls.rotate)),
        brightness: Math.round(Number(controls.brightness)),
        contrast: Math.round(Number(controls.contrast)),
        saturation: Math.round(Number(controls.saturation)),
        grayscale: Math.round(Number(controls.grayscale))
      };
      const styleSummary = 'Brightness ' + payload.brightness + '%, Contrast ' + payload.contrast + '%, Color ' + payload.saturation + '%, Black & white ' + payload.grayscale + '%';
      if (cropInput) cropInput.value = JSON.stringify(payload);
      if (adjustmentsInput) adjustmentsInput.value = styleSummary;
      if (publicStyleInput) publicStyleInput.value = styleSummary;
      if (previewNoteInput) previewNoteInput.value = 'Customer approved the on-screen puzzle preview. Piece grid, crop data and variant are included in hidden order properties.';
      if (selectedProductInput) selectedProductInput.value = 'Custom Photo Puzzle';
      writeState({ puzzleCrop: payload });
      return payload;
    }

    function applyTransform() {
      if (!previewImage) return;
      syncInputs();
      previewImage.style.transform = 'translate(calc(-50% + ' + controls.x + 'px), calc(-50% + ' + controls.y + 'px)) rotate(' + controls.rotate + 'deg) scale(' + controls.zoom + ')';
      previewImage.style.filter = currentFilter();
      updateCropData();
    }

    function loadDataUrl(src) {
      if (!src || !previewImage || !previewStage) return;
      previewImage.src = src;
      previewStage.classList.add('has-image');
      imageLoaded = true;
      if (uploadLabel) uploadLabel.textContent = 'Photo uploaded - click to change';
      writeState({ originalPreviewDataUrl: src });
      updateAddButton();
      updatePuzzleOverlay();
      applyTransform();
    }

    function setFile(file) {
      if (!file) return;
      if (!file.type || file.type.indexOf('image/') !== 0) {
        if (status) status.textContent = 'Please upload an image file.';
        return;
      }
      selectedFile = file;
      syncSelectedFileToInput();
      fileToDataUrl(file).then(loadDataUrl);
    }

    function setControl(key, value) {
      if (key === 'zoom') controls.zoom = clamp(value, 1, 3);
      if (key === 'x') controls.x = clamp(value, -260, 260);
      if (key === 'y') controls.y = clamp(value, -260, 260);
      if (key === 'rotate') controls.rotate = clamp(value, -180, 180);
      if (key === 'brightness') controls.brightness = clamp(value, 60, 150);
      if (key === 'contrast') controls.contrast = clamp(value, 70, 150);
      if (key === 'saturation') controls.saturation = clamp(value, 0, 170);
      if (key === 'grayscale') controls.grayscale = clamp(value, 0, 100);
      applyTransform();
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        const file = fileInput.files && fileInput.files[0];
        setFile(file);
      });
    }

    document.addEventListener('creodise:puzzle-photo-url', function (event) {
      if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl);
    });

    document.addEventListener('creodise:master-photo', function (event) {
      if (event.detail && event.detail.file) {
        selectedFile = event.detail.file;
        syncSelectedFileToInput();
      } else if (cdMasterFile) {
        selectedFile = cdMasterFile;
        syncSelectedFileToInput();
      }
      if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl);
      updateAddButton();
    });

    Object.keys(inputs).forEach(function (key) {
      const input = inputs[key];
      if (!input) return;
      input.addEventListener('input', function () { setControl(key, input.value); });
    });

    actionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const action = button.getAttribute('data-cd-action');
        if (action === 'zoom-in') setControl('zoom', Number(controls.zoom) + 0.08);
        if (action === 'zoom-out') setControl('zoom', Number(controls.zoom) - 0.08);
        if (action === 'center') {
          controls.x = 0; controls.y = 0; controls.rotate = 0; applyTransform();
        }
        if (action === 'rotate-left') setControl('rotate', Number(controls.rotate) - 1);
        if (action === 'rotate-right') setControl('rotate', Number(controls.rotate) + 1);
        if (action === 'rotate-90-left') setControl('rotate', Number(controls.rotate) - 90);
        if (action === 'rotate-90-right') setControl('rotate', Number(controls.rotate) + 90);
      });
    });

    function setFilterPreset(name) {
      if (name === 'bright') { controls.brightness = 112; controls.contrast = 106; controls.saturation = 112; controls.grayscale = 0; }
      else if (name === 'soft') { controls.brightness = 104; controls.contrast = 94; controls.saturation = 92; controls.grayscale = 0; }
      else if (name === 'bw') { controls.brightness = 104; controls.contrast = 112; controls.saturation = 0; controls.grayscale = 100; }
      else { controls.brightness = 100; controls.contrast = 100; controls.saturation = 100; controls.grayscale = 0; }
      filterPresetButtons.forEach(function (btn) { btn.classList.toggle('is-active', btn.getAttribute('data-cd-filter-preset') === name); });
      applyTransform();
    }

    filterPresetButtons.forEach(function (button) {
      button.addEventListener('click', function () { setFilterPreset(button.getAttribute('data-cd-filter-preset') || 'natural'); });
    });

    if (previewStage && window.PointerEvent) {
      previewStage.addEventListener('pointerdown', function (event) {
        if (!imageLoaded) return;
        dragging = true;
        previewStage.classList.add('is-dragging');
        previewStage.setPointerCapture(event.pointerId);
        dragStart = { x: event.clientX, y: event.clientY, cx: Number(controls.x), cy: Number(controls.y) };
      });
      previewStage.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        const dx = event.clientX - dragStart.x;
        const dy = event.clientY - dragStart.y;
        setControl('x', dragStart.cx + dx);
        setControl('y', dragStart.cy + dy);
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (name) {
        previewStage.addEventListener(name, function (event) {
          if (!dragging) return;
          dragging = false;
          previewStage.classList.remove('is-dragging');
          try { previewStage.releasePointerCapture(event.pointerId); } catch (e) {}
        });
      });
    }

    if (previewStage) {
      previewStage.addEventListener('wheel', function (event) {
        if (!imageLoaded) return;
        event.preventDefault();
        const delta = event.deltaY > 0 ? -0.04 : 0.04;
        setControl('zoom', Number(controls.zoom) + delta);
      }, { passive: false });
    }

    variantRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        const rawTitle = radio.getAttribute('data-title') || '';
        const displayTitle = radio.getAttribute('data-display-title') || rawTitle;
        if (variantInput) variantInput.value = radio.value;
        if (variantTitle) variantTitle.textContent = displayTitle;
        if (variantPrice) variantPrice.textContent = formatMoney(radio.getAttribute('data-price'));
        updateGridFromRadio(radio);
        writeState({ selectedVariantId: radio.value, selectedVariantTitle: displayTitle });
        updateAddButton();
      });
    });

    updatePieceBadges();
    const checked = root.querySelector('[data-cd-variant-radio]:checked');
    if (checked) checked.dispatchEvent(new Event('change'));
    else updatePuzzleOverlay();

    function drawEditedImageToCanvas(ctx, width, height, stageRect) {
      const img = previewImage;
      ctx.fillStyle = '#f3eee8';
      ctx.fillRect(0, 0, width, height);
      const naturalW = img.naturalWidth || width;
      const naturalH = img.naturalHeight || height;
      const containScale = Math.min(width / naturalW, height / naturalH);
      const drawW = naturalW * containScale;
      const drawH = naturalH * containScale;
      const xOffset = Number(controls.x || 0) * (width / Math.max(stageRect.width, 1));
      const yOffset = Number(controls.y || 0) * (height / Math.max(stageRect.height, 1));
      ctx.save();
      if ('filter' in ctx) ctx.filter = currentFilter();
      ctx.translate(width / 2 + xOffset, height / 2 + yOffset);
      ctx.rotate(Number(controls.rotate || 0) * Math.PI / 180);
      ctx.scale(Number(controls.zoom || 1), Number(controls.zoom || 1));
      ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
      ctx.restore();
      if ('filter' in ctx) ctx.filter = 'none';
    }

    function makeCanvasBlob(options) {
      return new Promise(function (resolve) {
        if (!previewStage || !previewImage || !imageLoaded) return resolve(null);
        const includePuzzle = !!(options && options.includePuzzle);
        const quality = options && options.quality ? options.quality : 0.9;
        const canvas = document.createElement('canvas');
        const rect = previewStage.getBoundingClientRect();
        const width = includePuzzle ? 1000 : 1600;
        const height = Math.round(width * (rect.height / Math.max(rect.width, 1)));
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        drawEditedImageToCanvas(ctx, width, height, rect);

        if (includePuzzle) {
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.strokeStyle = 'rgba(0,0,0,.24)';
          ctx.lineWidth = currentGrid.pieces >= 500 ? 1.25 : 2.2;
          drawPuzzlePathOnCanvas(ctx, currentGrid.cols, currentGrid.rows, width, height);
          ctx.strokeStyle = 'rgba(255,255,255,.78)';
          ctx.lineWidth = currentGrid.pieces >= 500 ? 0.7 : 1.35;
          drawPuzzlePathOnCanvas(ctx, currentGrid.cols, currentGrid.rows, width, height);
          ctx.strokeStyle = 'rgba(255,255,255,.65)';
          ctx.lineWidth = 2;
          ctx.strokeRect(1, 1, width - 2, height - 2);
        }

        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', quality);
      });
    }

    function attachFileToInput(input, blob, filename) {
      if (!blob || !input || !window.DataTransfer || !window.File) return false;
      try {
        const file = new File([blob], filename, { type: 'image/jpeg' });
        const dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        return true;
      } catch (e) {
        return false;
      }
    }

    if (rightsCheckbox) {
      rightsCheckbox.addEventListener('change', updateAddButton);
    }

    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (form.getAttribute('data-cd-ready-submit') === 'true') return;
        event.preventDefault();
        updateCropData();
        syncSelectedFileToInput();
        if (!imageLoaded) {
          if (status) status.textContent = 'Please upload a photo before adding to cart.';
          return;
        }
        if (!hasOrderFile()) {
          if (status) status.textContent = 'Please attach the original photo file before adding to cart.';
          return;
        }
        if (!variantInput || !variantInput.value) {
          if (status) status.textContent = 'Please select a puzzle option before adding to cart.';
          return;
        }
        if (rightsCheckbox && !rightsCheckbox.checked) {
          if (status) status.textContent = 'Please confirm you have the right to use this image.';
          return;
        }
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Preparing files...';
        }
        if (status) status.textContent = 'Preparing edited production image...';
        Promise.all([
          makeCanvasBlob({ includePuzzle: false, quality: 0.92 }),
          makeCanvasBlob({ includePuzzle: true, quality: 0.82 })
        ]).then(function (blobs) {
          attachFileToInput(editedFileInput, blobs[0], 'creodise-edited-photo.jpg');
          attachFileToInput(previewFileInput, blobs[1], 'creodise-puzzle-preview-reference.jpg');
          form.setAttribute('data-cd-ready-submit', 'true');
          if (status) status.textContent = 'Adding to cart...';
          if (addButton) addButton.textContent = 'Adding to cart...';
          form.submit();
        }).catch(function () {
          form.setAttribute('data-cd-ready-submit', 'true');
          form.submit();
        });
      });
    }

    const stored = readState();
    if (stored.originalPreviewDataUrl) loadDataUrl(stored.originalPreviewDataUrl);
    updateAddButton();
    applyTransform();
  }


  function inferSongStandType(title) {
    const text = String(title || '').toLowerCase();
    if (text.includes('led')) return 'led';
    if (text.includes('wood') || text.includes('wooden')) return 'wood';
    return 'wood';
  }

  function inferSongSize(title) {
    const text = String(title || '').toLowerCase().replace(/\s+/g, '');
    if (text.includes('12x8')) return '12x8';
    if (text.includes('10x8')) return '10x8';
    if (text.includes('8x6')) return '8x6';
    if (text.includes('6x4')) return '6x4';
    return '6x4';
  }

  function humanSongStand(type) {
    return type === 'led' ? 'LED Stand' : 'Wooden Stand';
  }

  function humanSongSize(size) {
    if (size === '12x8') return '12 × 8 in';
    if (size === '10x8') return '10 × 8 in';
    if (size === '8x6') return '8 × 6 in';
    return '6 × 4 in';
  }

  function initSongBuilder(root) {
    const configEl = root.querySelector('[data-cd-song-config]');
    if (!configEl) return;

    const form = root.querySelector('[data-cd-song-form]');
    const fileInput = root.querySelector('[data-cd-song-upload]');
    const previewFileInput = root.querySelector('[data-cd-song-preview-upload]');
    const croppedFileInput = root.querySelector('[data-cd-song-cropped-upload]');
    const uploadLabel = root.querySelector('[data-cd-song-upload-label]');
    const previewImage = root.querySelector('[data-cd-song-image]');
    const placeholder = root.querySelector('[data-cd-song-placeholder]');
    const stage = root.querySelector('[data-cd-song-stage]');
    const variantInput = root.querySelector('[data-cd-song-variant-input]');
    const variantDataEls = Array.from(root.querySelectorAll('[data-cd-song-variant-data]'));
    const selectedTitle = root.querySelector('[data-cd-song-selected-title]');
    const selectedPrice = root.querySelector('[data-cd-song-selected-price]');
    const selectedColor = root.querySelector('[data-cd-song-selected-color]');
    const selectedQr = root.querySelector('[data-cd-song-selected-qr]');
    const selectedStand = root.querySelector('[data-cd-song-selected-stand]');
    const selectedSize = root.querySelector('[data-cd-song-selected-size]');
    const addButton = root.querySelector('[data-cd-song-add]');
    const status = root.querySelector('[data-cd-song-status]');
    const rights = root.querySelector('[data-cd-song-rights]');
    const designInput = root.querySelector('[data-cd-song-design-data]');
    const fields = root.querySelectorAll('[data-cd-song-field]');
    const colorRadios = root.querySelectorAll('[data-cd-song-color]');
    const qrRadios = root.querySelectorAll('[data-cd-song-qr-mode]');
    const standRadios = root.querySelectorAll('[data-cd-song-stand-choice]');
    const sizeRadios = root.querySelectorAll('[data-cd-song-size-choice]');
    const standProperty = root.querySelector('[data-cd-song-stand-property]');
    const sizeProperty = root.querySelector('[data-cd-song-size-property]');
    const qrUrlWrap = root.querySelector('[data-cd-song-qr-url-wrap]');
    const qrPanel = root.querySelector('[data-cd-song-qr-panel]');
    const qrInput = root.querySelector('[data-cd-song-qr-input]');
    const qrApply = root.querySelector('[data-cd-song-qr-apply]');
    const qrStatus = root.querySelector('[data-cd-song-qr-status]');
    const qrImg = root.querySelector('[data-cd-song-qr-img]');
    const qrPlaceholder = root.querySelector('[data-cd-song-qr-placeholder]');
    const photoWrap = root.querySelector('[data-cd-song-photo-wrap]');
    const zoomInput = root.querySelector('[data-cd-song-zoom]');
    const centerButton = root.querySelector('[data-cd-song-center]');
    const songAdjustmentInputs = {
      brightness: root.querySelector('[data-cd-song-control="brightness"]'),
      contrast: root.querySelector('[data-cd-song-control="contrast"]'),
      saturation: root.querySelector('[data-cd-song-control="saturation"]'),
      grayscale: root.querySelector('[data-cd-song-control="grayscale"]')
    };
    const songAdjustmentLabels = {
      brightness: root.querySelector('[data-cd-song-value="brightness"]'),
      contrast: root.querySelector('[data-cd-song-value="contrast"]'),
      saturation: root.querySelector('[data-cd-song-value="saturation"]'),
      grayscale: root.querySelector('[data-cd-song-value="grayscale"]')
    };
    const songFilterButtons = root.querySelectorAll('[data-cd-song-filter-preset]');

    const variants = variantDataEls.map(function (el) {
      return {
        id: el.getAttribute('data-id') || '',
        title: el.getAttribute('data-title') || '',
        price: el.getAttribute('data-price') || '',
        priceFormatted: el.getAttribute('data-price-formatted') || '',
        size: el.getAttribute('data-size') || inferSongSize(el.getAttribute('data-title')),
        stand: el.getAttribute('data-stand') || inferSongStandType(el.getAttribute('data-title')),
        available: el.getAttribute('data-available') === 'true',
        productTitle: el.getAttribute('data-product-title') || '',
        productHandle: el.getAttribute('data-product-handle') || ''
      };
    });

    let selectedFile = null;
    let imageLoaded = false;
    let currentColor = 'black';
    let currentQrMode = 'no';
    let appliedQrUrl = '';
    let currentStandType = 'wood';
    let currentSize = '6x4';
    let currentVariant = null;
    let currentVariantTitle = '';
    let songZoom = 1;
    let songX = 0;
    let songY = 0;
    let songAdjustments = { brightness: 100, contrast: 100, saturation: 100, grayscale: 0 };
    let draggingSong = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let startSongX = 0;
    let startSongY = 0;

    function currentSongFilter() {
      return 'brightness(' + Number(songAdjustments.brightness) + '%) contrast(' + Number(songAdjustments.contrast) + '%) saturate(' + Number(songAdjustments.saturation) + '%) grayscale(' + Number(songAdjustments.grayscale) + '%)';
    }

    function syncSongAdjustmentInputs() {
      Object.keys(songAdjustmentInputs).forEach(function (key) {
        const input = songAdjustmentInputs[key];
        if (input) input.value = String(songAdjustments[key]);
      });
      if (songAdjustmentLabels.brightness) songAdjustmentLabels.brightness.textContent = Math.round(songAdjustments.brightness) + '%';
      if (songAdjustmentLabels.contrast) songAdjustmentLabels.contrast.textContent = Math.round(songAdjustments.contrast) + '%';
      if (songAdjustmentLabels.saturation) songAdjustmentLabels.saturation.textContent = Math.round(songAdjustments.saturation) + '%';
      if (songAdjustmentLabels.grayscale) songAdjustmentLabels.grayscale.textContent = Math.round(songAdjustments.grayscale) + '%';
    }

    function setSongAdjustment(key, value) {
      if (key === 'brightness') songAdjustments.brightness = clamp(value, 60, 150);
      if (key === 'contrast') songAdjustments.contrast = clamp(value, 70, 150);
      if (key === 'saturation') songAdjustments.saturation = clamp(value, 0, 170);
      if (key === 'grayscale') songAdjustments.grayscale = clamp(value, 0, 100);
      applySongPhotoTransform();
    }

    function setSongFilterPreset(name) {
      if (name === 'bright') { songAdjustments.brightness = 112; songAdjustments.contrast = 106; songAdjustments.saturation = 112; songAdjustments.grayscale = 0; }
      else if (name === 'soft') { songAdjustments.brightness = 104; songAdjustments.contrast = 94; songAdjustments.saturation = 92; songAdjustments.grayscale = 0; }
      else if (name === 'bw') { songAdjustments.brightness = 104; songAdjustments.contrast = 112; songAdjustments.saturation = 0; songAdjustments.grayscale = 100; }
      else { songAdjustments.brightness = 100; songAdjustments.contrast = 100; songAdjustments.saturation = 100; songAdjustments.grayscale = 0; }
      songFilterButtons.forEach(function (btn) { btn.classList.toggle('is-active', btn.getAttribute('data-cd-song-filter-preset') === (name || 'natural')); });
      applySongPhotoTransform();
    }

    function syncSelectedFileToInput() {
      if (!selectedFile || !fileInput || !window.DataTransfer) return;
      try {
        const dt = new DataTransfer();
        dt.items.add(selectedFile);
        fileInput.files = dt.files;
      } catch (e) {}
    }

    function setText(selector, value, fallback) {
      const el = root.querySelector(selector);
      if (el) el.textContent = value || fallback;
    }

    function updateRightTimeClass() {
      const rightEl = root.querySelector('[data-cd-song-right]');
      if (!rightEl) return;
      const rawValue = getField('right');
      const shownValue = rawValue || '∞';
      rightEl.classList.toggle('is-infinity', shownValue === '∞');
    }

    function getField(name) {
      const input = root.querySelector('[data-cd-song-field="' + name + '"]');
      return input ? input.value.trim() : '';
    }

    function findSongVariant(stand, size) {
      return variants.find(function (variant) {
        return variant.stand === stand && variant.size === size && variant.available;
      }) || variants.find(function (variant) {
        return variant.stand === stand && variant.available;
      }) || variants.find(function (variant) {
        return variant.available;
      }) || variants[0] || null;
    }

    function normalizeQrUrl(value) {
      const raw = String(value || '').trim();
      if (!raw) return '';
      if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) return raw;
      return 'https://' + raw;
    }

    function qrPreviewSrc(url) {
      return 'https://api.qrserver.com/v1/create-qr-code/?size=420x420&margin=0&data=' + encodeURIComponent(url);
    }

    function updateQrPreview() {
      const hasApplied = currentQrMode === 'with' && !!appliedQrUrl;
      if (qrImg) {
        if (hasApplied) {
          qrImg.src = qrPreviewSrc(appliedQrUrl);
          qrImg.hidden = false;
        } else {
          qrImg.removeAttribute('src');
          qrImg.hidden = true;
        }
      }
      if (qrPlaceholder) {
        qrPlaceholder.hidden = hasApplied;
        qrPlaceholder.textContent = currentQrMode === 'with' ? 'QR' : 'QR';
      }
      if (qrStatus) {
        if (currentQrMode !== 'with') qrStatus.textContent = 'QR is turned off for this design.';
        else if (appliedQrUrl) qrStatus.textContent = 'QR preview generated from your link.';
        else qrStatus.textContent = 'Paste a link and press Submit QR to show it on the plaque.';
      }
    }

    function applyQrUrl() {
      if (!qrInput) return;
      const normalized = normalizeQrUrl(qrInput.value);
      if (!normalized) {
        appliedQrUrl = '';
        updateQrPreview();
        updateDesignData();
        updateSongButton();
        return;
      }
      appliedQrUrl = normalized;
      qrInput.value = normalized;
      updateQrPreview();
      updateDesignData();
      updateSongButton();
    }

    function updateQrLayout() {
      if (stage) stage.setAttribute('data-qr', currentQrMode);
      if (qrUrlWrap) qrUrlWrap.classList.toggle('is-hidden', currentQrMode !== 'with');
      if (qrPanel) qrPanel.classList.toggle('is-hidden', currentQrMode !== 'with');
      if (selectedQr) selectedQr.textContent = currentQrMode === 'with' ? 'With QR code' : 'Without QR code';
      updateQrPreview();
    }

    function updatePreviewText() {
      setText('[data-cd-song-title]', getField('title'), 'Our Song');
      setText('[data-cd-song-subtitle]', getField('subtitle'), 'Your names or special message');
      setText('[data-cd-song-left]', getField('left'), '00:00');
      setText('[data-cd-song-right]', getField('right'), '∞');
      updateRightTimeClass();
      updateDesignData();
      updateSongButton();
    }

    function applyCrystalLayout() {
      if (!stage || !photoWrap) return;
      const spec = crystalVariantSpec(currentVariant || { shape: currentShape, title: '' });
      const scale = spec.scale || 1;
      stage.style.setProperty('--cd-crystal-product-scale', String(scale));
      stage.setAttribute('data-size', (spec.label || '').toLowerCase());
      const cx = currentShape === 'rect' ? 50.6 : 50.0;
      const cy = currentShape === 'rect' ? 43.0 : 43.0;
      let w, h, top;
      if (currentShape === 'rect') {
        h = 55 * scale;
        w = h * (spec.ratio || .67);
        top = 15.5 + (1 - scale) * 8;
      } else {
        w = 72 * scale;
        h = Math.min(64, (w / (spec.ratio || 1.14)));
        top = 13.2 + (1 - scale) * 6;
      }
      const left = cx - w / 2;
      photoWrap.style.left = left.toFixed(2) + '%';
      photoWrap.style.top = top.toFixed(2) + '%';
      photoWrap.style.width = w.toFixed(2) + '%';
      photoWrap.style.height = h.toFixed(2) + '%';
      if (currentShape === 'rect') {
        photoWrap.style.borderRadius = '7px';
      } else {
        photoWrap.style.borderRadius = '';
      }
    }

    function updateDesignData() {
      if (!designInput) return;
      const data = {
        product_type: 'acrylic_music_plaque',
        variant_title: currentVariantTitle,
        variant_id: currentVariant ? currentVariant.id : '',
        qr_option: currentQrMode === 'with' ? 'with_qr' : 'without_qr',
        text_color: currentColor,
        main_title: getField('title'),
        subtitle: getField('subtitle'),
        left_time: getField('left'),
        right_time: getField('right'),
        qr_url: currentQrMode === 'with' ? (appliedQrUrl || getField('qr')) : '',
        notes: getField('notes'),
        preview_type: 'song_plaque_blank_mockup_v22',
        stand_type: currentStandType,
        plaque_size: currentSize,
        photo_zoom: songZoom,
        photo_x: Math.round(songX),
        photo_y: Math.round(songY),
        brightness: Math.round(songAdjustments.brightness),
        contrast: Math.round(songAdjustments.contrast),
        saturation: Math.round(songAdjustments.saturation),
        grayscale: Math.round(songAdjustments.grayscale),
        photo_style: 'Brightness ' + Math.round(songAdjustments.brightness) + '%, Contrast ' + Math.round(songAdjustments.contrast) + '%, Color ' + Math.round(songAdjustments.saturation) + '%, Black & white ' + Math.round(songAdjustments.grayscale) + '%',
        ai_ready: true
      };
      designInput.value = JSON.stringify(data);
    }

    function updateSongVariant() {
      currentVariant = findSongVariant(currentStandType, currentSize);
      if (currentVariant) {
        currentVariantTitle = currentVariant.title;
        if (variantInput) variantInput.value = currentVariant.id;
        if (selectedTitle) selectedTitle.textContent = currentVariant.title;
        if (selectedPrice) selectedPrice.textContent = currentVariant.priceFormatted || formatMoney(currentVariant.price);
      } else {
        currentVariantTitle = '';
        if (variantInput) variantInput.value = '';
        if (selectedTitle) selectedTitle.textContent = 'Unavailable combination';
        if (selectedPrice) selectedPrice.textContent = '-';
      }
      if (stage) {
        stage.setAttribute('data-stand', currentStandType);
        stage.setAttribute('data-size', currentSize);
      }
      if (selectedStand) selectedStand.textContent = humanSongStand(currentStandType);
      if (selectedSize) selectedSize.textContent = humanSongSize(currentSize);
      if (standProperty) standProperty.value = humanSongStand(currentStandType);
      if (sizeProperty) sizeProperty.value = humanSongSize(currentSize);
      updateDesignData();
      updateSongButton();
    }

    function updateSongButton() {
      const hasPhoto = !!selectedFile || (fileInput && fileInput.files && fileInput.files[0]);
      const hasVariant = !!(variantInput && variantInput.value);
      const hasTitle = !!getField('title');
      const hasRights = !rights || rights.checked;
      const needsQrUrl = currentQrMode === 'with';
      const hasQrUrl = !!appliedQrUrl;
      const ready = hasPhoto && hasVariant && hasTitle && hasRights && (!needsQrUrl || hasQrUrl);
      if (addButton) addButton.disabled = !ready;
      if (status) {
        if (!hasPhoto) status.textContent = 'Upload a photo to continue.';
        else if (!hasVariant) status.textContent = 'This stand and size combination is unavailable.';
        else if (!hasTitle) status.textContent = 'Add a main title or song name to continue.';
        else if (needsQrUrl && !hasQrUrl) status.textContent = 'Paste your QR link and press Submit QR, or choose Without QR.';
        else if (!hasRights) status.textContent = 'Confirm image rights to continue.';
        else status.textContent = 'Ready to add to cart.';
      }
    }

    function applySongPhotoTransform() {
      if (!previewImage) return;
      syncSongAdjustmentInputs();
      previewImage.style.setProperty('--cd-song-photo-zoom', String(songZoom));
      previewImage.style.setProperty('--cd-song-photo-x', songX + 'px');
      previewImage.style.setProperty('--cd-song-photo-y', songY + 'px');
      previewImage.style.filter = currentSongFilter();
      updateDesignData();
    }

    function loadDataUrl(dataUrl) {
      if (!previewImage) return;
      previewImage.onload = function () {
        imageLoaded = true;
        songZoom = 1;
        songX = 0;
        songY = 0;
        if (zoomInput) zoomInput.value = 100;
        applySongPhotoTransform();
        if (placeholder) placeholder.style.display = 'none';
        previewImage.classList.add('is-loaded');
        updateSongButton();
      };
      previewImage.src = dataUrl;
    }

    function loadFile(file) {
      if (!file) return;
      selectedFile = file;
      if (uploadLabel) uploadLabel.textContent = file.name || 'Photo uploaded';
      fileToDataUrl(file).then(function (dataUrl) {
        loadDataUrl(dataUrl);
        writeState({ originalPreviewDataUrl: dataUrl });
      });
      updateSongButton();
    }

    document.addEventListener('creodise:master-photo', function (event) {
      if (event.detail && event.detail.file) {
        selectedFile = event.detail.file;
        syncSelectedFileToInput();
      } else if (cdMasterFile) {
        selectedFile = cdMasterFile;
        syncSelectedFileToInput();
      }
      if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl);
      if (uploadLabel && selectedFile) uploadLabel.textContent = selectedFile.name || 'Photo uploaded';
      updateSongButton();
    });

    document.addEventListener('creodise:song-photo-url', function (event) {
      if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl);
    });

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        const file = fileInput.files && fileInput.files[0];
        loadFile(file);
      });
    }

    qrRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        currentQrMode = radio.getAttribute('data-cd-song-qr-mode') || 'no';
        if (currentQrMode !== 'with') appliedQrUrl = '';
        updateQrLayout();
        updateDesignData();
        updateSongButton();
      });
    });

    standRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        currentStandType = radio.value || 'wood';
        updateSongVariant();
      });
    });

    sizeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        currentSize = radio.value || '6x4';
        updateSongVariant();
      });
    });

    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        if (field === qrInput && appliedQrUrl && normalizeQrUrl(field.value) !== appliedQrUrl) {
          appliedQrUrl = '';
          updateQrPreview();
        }
        updatePreviewText();
      });
    });

    if (qrApply) {
      qrApply.addEventListener('click', applyQrUrl);
    }
    if (qrInput) {
      qrInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyQrUrl();
        }
      });
    }

    colorRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        currentColor = radio.getAttribute('data-cd-song-color') || 'black';
        if (stage) stage.setAttribute('data-color', currentColor);
        if (selectedColor) selectedColor.textContent = radio.value || currentColor;
        updateDesignData();
      });
    });

    if (zoomInput) {
      zoomInput.addEventListener('input', function () {
        songZoom = clamp(Number(zoomInput.value || 100) / 100, 1, 2.2);
        applySongPhotoTransform();
      });
    }

    if (centerButton) {
      centerButton.addEventListener('click', function () {
        songX = 0;
        songY = 0;
        songZoom = 1;
        if (zoomInput) zoomInput.value = 100;
        applySongPhotoTransform();
      });
    }

    Object.keys(songAdjustmentInputs).forEach(function (key) {
      const input = songAdjustmentInputs[key];
      if (!input) return;
      input.addEventListener('input', function () { setSongAdjustment(key, input.value); });
    });

    songFilterButtons.forEach(function (button) {
      button.addEventListener('click', function () { setSongFilterPreset(button.getAttribute('data-cd-song-filter-preset') || 'natural'); });
    });

    if (photoWrap) {
      photoWrap.addEventListener('pointerdown', function (event) {
        if (!imageLoaded) return;
        draggingSong = true;
        photoWrap.classList.add('is-dragging');
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        startSongX = songX;
        startSongY = songY;
        if (photoWrap.setPointerCapture) photoWrap.setPointerCapture(event.pointerId);
      });
      photoWrap.addEventListener('pointermove', function (event) {
        if (!draggingSong) return;
        songX = startSongX + (event.clientX - dragStartX);
        songY = startSongY + (event.clientY - dragStartY);
        applySongPhotoTransform();
      });
      photoWrap.addEventListener('pointerup', function (event) {
        draggingSong = false;
        photoWrap.classList.remove('is-dragging');
        if (photoWrap.releasePointerCapture) photoWrap.releasePointerCapture(event.pointerId);
      });
      photoWrap.addEventListener('pointercancel', function () {
        draggingSong = false;
        photoWrap.classList.remove('is-dragging');
      });
    }

    if (rights) rights.addEventListener('change', updateSongButton);

    function attachFileToInput(input, blob, filename) {
      if (!blob || !input || !window.DataTransfer || !window.File) return false;
      try {
        const file = new File([blob], filename, { type: 'image/jpeg' });
        const dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        return true;
      } catch (e) {
        return false;
      }
    }

    function drawCoverImage(ctx, img, x, y, w, h, useSongTransform) {
      const naturalW = img.naturalWidth || w;
      const naturalH = img.naturalHeight || h;
      const baseScale = Math.max(w / naturalW, h / naturalH);
      const scale = baseScale * (useSongTransform ? songZoom : 1);
      const drawW = naturalW * scale;
      const drawH = naturalH * scale;
      const factor = w / Math.max(1, (photoWrap && photoWrap.clientWidth) || w);
      const dx = useSongTransform ? songX * factor : 0;
      const dy = useSongTransform ? songY * factor : 0;
      ctx.save();
      if ('filter' in ctx) ctx.filter = currentSongFilter();
      ctx.drawImage(img, x + (w - drawW) / 2 + dx, y + (h - drawH) / 2 + dy, drawW, drawH);
      ctx.restore();
    }

    function makeCroppedPhotoBlob() {
      return new Promise(function (resolve) {
        if (!previewImage || !imageLoaded) return resolve(null);
        const canvas = document.createElement('canvas');
        canvas.width = 1200;
        canvas.height = 1200;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#f6f2ec';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        drawCoverImage(ctx, previewImage, 0, 0, canvas.width, canvas.height, true);
        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.92);
      });
    }

    function makePreviewBlob() {
      return new Promise(function (resolve) {
        if (!previewImage || !imageLoaded) return resolve(null);
        const canvas = document.createElement('canvas');
        canvas.width = 1000;
        canvas.height = 1450;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#eee7dc';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = 'rgba(255,255,255,.72)';
        roundRect(ctx, 110, 70, 780, 1190, 48);
        ctx.fill();
        ctx.strokeStyle = 'rgba(255,255,255,.9)';
        ctx.lineWidth = 4;
        ctx.stroke();
        drawCoverImage(ctx, previewImage, 170, 140, 660, 520, true);
        const color = currentColor === 'white' ? '#ffffff' : currentColor === 'gold' ? '#c19438' : '#171717';
        ctx.fillStyle = color;
        ctx.textAlign = 'left';
        const hasQr = currentQrMode === 'with';
        const textX = hasQr ? 330 : 250;
        const qrY = 830;
        if (hasQr) {
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(190, qrY, 105, 105);
          ctx.fillStyle = '#111111';
          var qrSeed = String(appliedQrUrl || getField('qr') || 'creodise');
          var hash = 0;
          for (var hi = 0; hi < qrSeed.length; hi++) hash = ((hash << 5) - hash + qrSeed.charCodeAt(hi)) | 0;
          var cell = 5;
          function finder(fx, fy) {
            ctx.fillRect(190 + fx, qrY + fy, 35, 35);
            ctx.fillStyle = '#ffffff'; ctx.fillRect(190 + fx + 5, qrY + fy + 5, 25, 25);
            ctx.fillStyle = '#111111'; ctx.fillRect(190 + fx + 11, qrY + fy + 11, 13, 13);
          }
          finder(5, 5); finder(65, 5); finder(5, 65);
          for (var qy = 0; qy < 21; qy++) {
            for (var qx = 0; qx < 21; qx++) {
              var inFinder = (qx < 8 && qy < 8) || (qx > 12 && qy < 8) || (qx < 8 && qy > 12);
              if (inFinder) continue;
              var bit = ((hash + qx * 17 + qy * 31 + qx * qy * 7) % 5) < 2;
              if (bit) ctx.fillRect(190 + qx * cell, qrY + qy * cell, cell, cell);
            }
          }
          ctx.strokeStyle = color;
          ctx.lineWidth = 2;
          ctx.strokeRect(190, qrY, 105, 105);
          ctx.fillStyle = color;
        }
        ctx.font = '700 54px Arial, sans-serif';
        ctx.fillText(getField('title') || 'Our Song', textX, 870, hasQr ? 460 : 560);
        ctx.font = '400 32px Arial, sans-serif';
        ctx.fillText(getField('subtitle') || 'Your names or special message', textX, 925, hasQr ? 460 : 560);
        ctx.strokeStyle = color;
        ctx.lineWidth = 6;
        ctx.beginPath();
        ctx.moveTo(190, 1015);
        ctx.lineTo(810, 1015);
        ctx.stroke();
        ctx.fillStyle = color;
        ctx.font = '400 26px Arial, sans-serif';
        ctx.fillText(getField('left') || '00:00', 190, 1055);
        ctx.textAlign = 'right';
        var rightTextForCanvas = getField('right') || '∞';
        ctx.font = rightTextForCanvas === '∞' ? '700 40px Arial, sans-serif' : '400 26px Arial, sans-serif';
        ctx.fillText(rightTextForCanvas, 810, 1055);
        ctx.textAlign = 'center';
        ctx.font = '700 28px Arial, sans-serif';
        ctx.fillText(currentQrMode === 'with' ? 'QR / Custom URL included' : 'No QR code layout', 500, 1135, 690);
        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.86);
      });
    }

    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + w - r, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r);
      ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
      ctx.closePath();
    }

    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (form.getAttribute('data-cd-ready-submit') === 'true') return;
        event.preventDefault();
        syncSelectedFileToInput();
        updateDesignData();
        if (!selectedFile && !(fileInput && fileInput.files && fileInput.files[0])) {
          if (status) status.textContent = 'Please upload a photo before adding to cart.';
          return;
        }
        if (!variantInput || !variantInput.value) {
          if (status) status.textContent = 'Please choose a plaque size and stand option.';
          return;
        }
        if (!getField('title')) {
          if (status) status.textContent = 'Please add a main title or song name.';
          return;
        }
        if (currentQrMode === 'with' && !appliedQrUrl) {
          if (status) status.textContent = 'Please paste your QR link and press Submit QR, or choose Without QR.';
          return;
        }
        if (rights && !rights.checked) {
          if (status) status.textContent = 'Please confirm you have the right to use this image.';
          return;
        }
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Preparing files...';
        }
        if (status) status.textContent = 'Preparing plaque preview...';
        Promise.all([makeCroppedPhotoBlob(), makePreviewBlob()]).then(function (blobs) {
          attachFileToInput(croppedFileInput, blobs[0], 'creodise-plaque-cropped-photo.jpg');
          attachFileToInput(previewFileInput, blobs[1], 'creodise-plaque-preview-reference.jpg');
          form.setAttribute('data-cd-ready-submit', 'true');
          if (status) status.textContent = 'Adding to cart...';
          if (addButton) addButton.textContent = 'Adding to cart...';
          form.submit();
        }).catch(function () {
          form.setAttribute('data-cd-ready-submit', 'true');
          form.submit();
        });
      });
    }

    syncSongAdjustmentInputs();
    const stored = readState();
    if (stored.originalPreviewDataUrl) loadDataUrl(stored.originalPreviewDataUrl);
    updateQrLayout();
    updateSongVariant();
    updatePreviewText();
    updateSongButton();
  }


  function inferRecordSize(title) {
    const text = String(title || '').toLowerCase().replace(/\s+/g, '');
    if (text.indexOf('12x12') > -1) return '12x12';
    if (text.indexOf('8x8') > -1) return '8x8';
    return '6x6';
  }

  function humanRecordSize(size) {
    if (size === '12x12') return '12 × 12 in';
    if (size === '8x8') return '8 × 8 in';
    return '6 × 6 in';
  }

  function initRecordBuilder(root) {
    const form = root.querySelector('[data-cd-record-form]');
    const fileInput = root.querySelector('[data-cd-record-upload]');
    const previewFileInput = root.querySelector('[data-cd-record-preview-upload]');
    const croppedFileInput = root.querySelector('[data-cd-record-cropped-upload]');
    const uploadLabel = root.querySelector('[data-cd-record-upload-label]');
    const previewImage = root.querySelector('[data-cd-record-image]');
    const placeholder = root.querySelector('[data-cd-record-placeholder]');
    const stage = root.querySelector('[data-cd-record-stage]');
    const photoWrap = root.querySelector('[data-cd-record-photo-wrap]');
    const variantInput = root.querySelector('[data-cd-record-variant-input]');
    const variantDataEls = Array.from(root.querySelectorAll('[data-cd-record-variant-data]'));
    const selectedTitle = root.querySelector('[data-cd-record-selected-title]');
    const selectedPrice = root.querySelector('[data-cd-record-selected-price]');
    const selectedSize = root.querySelector('[data-cd-record-selected-size]');
    const sizeProperty = root.querySelector('[data-cd-record-size-property]');
    const designInput = root.querySelector('[data-cd-record-design-data]');
    const addButton = root.querySelector('[data-cd-record-add]');
    const status = root.querySelector('[data-cd-record-status]');
    const rights = root.querySelector('[data-cd-record-rights]');
    const fields = root.querySelectorAll('[data-cd-record-field]');
    const colorRadios = root.querySelectorAll('[data-cd-record-color]');
    const qrRadios = root.querySelectorAll('[data-cd-record-qr-mode]');
    const sizeRadios = root.querySelectorAll('[data-cd-record-size-choice]');
    const qrPanel = root.querySelector('[data-cd-record-qr-panel]');
    const qrInput = root.querySelector('[data-cd-record-qr-input]');
    const qrApply = root.querySelector('[data-cd-record-qr-apply]');
    const qrStatus = root.querySelector('[data-cd-record-qr-status]');
    const qrImg = root.querySelector('[data-cd-record-qr-img]');
    const qrPlaceholder = root.querySelector('[data-cd-record-qr-placeholder]');
    const zoomInput = root.querySelector('[data-cd-record-zoom]');
    const zoomValue = root.querySelector('[data-cd-record-zoom-value]');
    const centerButton = root.querySelector('[data-cd-record-center]');
    const recordAdjustmentInputs = {
      brightness: root.querySelector('[data-cd-record-control="brightness"]'),
      contrast: root.querySelector('[data-cd-record-control="contrast"]'),
      saturation: root.querySelector('[data-cd-record-control="saturation"]'),
      grayscale: root.querySelector('[data-cd-record-control="grayscale"]')
    };
    const recordAdjustmentLabels = {
      brightness: root.querySelector('[data-cd-record-value="brightness"]'),
      contrast: root.querySelector('[data-cd-record-value="contrast"]'),
      saturation: root.querySelector('[data-cd-record-value="saturation"]'),
      grayscale: root.querySelector('[data-cd-record-value="grayscale"]')
    };
    const filterButtons = root.querySelectorAll('[data-cd-record-filter-preset]');

    const variants = variantDataEls.map(function (el) {
      return {
        id: el.getAttribute('data-id') || '',
        title: el.getAttribute('data-title') || '',
        price: el.getAttribute('data-price') || '',
        priceFormatted: el.getAttribute('data-price-formatted') || '',
        size: el.getAttribute('data-size') || inferRecordSize(el.getAttribute('data-title')),
        available: el.getAttribute('data-available') === 'true',
        productTitle: el.getAttribute('data-product-title') || '',
        productHandle: el.getAttribute('data-product-handle') || ''
      };
    });

    let selectedFile = null;
    let imageLoaded = false;
    let currentColor = 'white';
    let currentQrMode = 'no';
    let appliedQrUrl = '';
    let currentSize = '6x6';
    let currentVariant = null;
    let currentVariantTitle = '';
    let recordZoom = 1;
    let recordX = 0;
    let recordY = 0;
    let recordAdjustments = { brightness: 100, contrast: 100, saturation: 100, grayscale: 0 };
    let dragging = false, dragStartX = 0, dragStartY = 0, startX = 0, startY = 0;

    function currentFilter() {
      return 'brightness(' + Number(recordAdjustments.brightness) + '%) contrast(' + Number(recordAdjustments.contrast) + '%) saturate(' + Number(recordAdjustments.saturation) + '%) grayscale(' + Number(recordAdjustments.grayscale) + '%)';
    }

    function syncAdjustmentInputs() {
      Object.keys(recordAdjustmentInputs).forEach(function (key) { if (recordAdjustmentInputs[key]) recordAdjustmentInputs[key].value = String(recordAdjustments[key]); });
      if (recordAdjustmentLabels.brightness) recordAdjustmentLabels.brightness.textContent = Math.round(recordAdjustments.brightness) + '%';
      if (recordAdjustmentLabels.contrast) recordAdjustmentLabels.contrast.textContent = Math.round(recordAdjustments.contrast) + '%';
      if (recordAdjustmentLabels.saturation) recordAdjustmentLabels.saturation.textContent = Math.round(recordAdjustments.saturation) + '%';
      if (recordAdjustmentLabels.grayscale) recordAdjustmentLabels.grayscale.textContent = Math.round(recordAdjustments.grayscale) + '%';
      if (zoomValue) zoomValue.textContent = Math.round(recordZoom * 100) + '%';
    }

    function setAdjustment(key, value) {
      if (key === 'brightness') recordAdjustments.brightness = clamp(value, 60, 150);
      if (key === 'contrast') recordAdjustments.contrast = clamp(value, 70, 150);
      if (key === 'saturation') recordAdjustments.saturation = clamp(value, 0, 170);
      if (key === 'grayscale') recordAdjustments.grayscale = clamp(value, 0, 100);
      applyPhotoTransform();
    }

    function setFilterPreset(name) {
      if (name === 'bright') { recordAdjustments.brightness = 112; recordAdjustments.contrast = 106; recordAdjustments.saturation = 112; recordAdjustments.grayscale = 0; }
      else if (name === 'soft') { recordAdjustments.brightness = 104; recordAdjustments.contrast = 94; recordAdjustments.saturation = 92; recordAdjustments.grayscale = 0; }
      else if (name === 'bw') { recordAdjustments.brightness = 104; recordAdjustments.contrast = 112; recordAdjustments.saturation = 0; recordAdjustments.grayscale = 100; }
      else { recordAdjustments.brightness = 100; recordAdjustments.contrast = 100; recordAdjustments.saturation = 100; recordAdjustments.grayscale = 0; }
      filterButtons.forEach(function (btn) { btn.classList.toggle('is-active', btn.getAttribute('data-cd-record-filter-preset') === (name || 'natural')); });
      applyPhotoTransform();
    }

    function syncFileToInput() {
      if (!selectedFile || !fileInput || !window.DataTransfer) return;
      try { const dt = new DataTransfer(); dt.items.add(selectedFile); fileInput.files = dt.files; } catch(e) {}
    }

    function getField(name) { const input = root.querySelector('[data-cd-record-field="' + name + '"]'); return input ? input.value.trim() : ''; }
    function setText(selector, value, fallback) { const el = root.querySelector(selector); if (el) el.textContent = value || fallback; }

    function updateRightClass() {
      const rightEl = root.querySelector('[data-cd-record-right]');
      if (!rightEl) return;
      const shown = getField('right') || '∞';
      rightEl.classList.toggle('is-infinity', shown === '∞');
    }

    function normalizeQrUrl(value) {
      const raw = String(value || '').trim();
      if (!raw) return '';
      if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) return raw;
      return 'https://' + raw;
    }
    function qrPreviewSrc(url) { return 'https://api.qrserver.com/v1/create-qr-code/?size=420x420&margin=0&data=' + encodeURIComponent(url); }

    function updateQrPreview() {
      const hasApplied = currentQrMode === 'with' && !!appliedQrUrl;
      const qrBox = root.querySelector('[data-cd-record-qr]');
      if (qrBox) {
        qrBox.classList.toggle('has-qr', hasApplied);
        qrBox.classList.toggle('is-empty', !hasApplied);
      }
      if (qrImg) {
        if (hasApplied) {
          qrImg.src = qrPreviewSrc(appliedQrUrl);
          qrImg.hidden = false;
        } else {
          qrImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
          qrImg.hidden = true;
        }
      }
      if (qrPlaceholder) {
        qrPlaceholder.hidden = true;
        qrPlaceholder.textContent = '';
      }
      if (qrStatus) {
        if (currentQrMode !== 'with') qrStatus.textContent = 'QR is turned off for this design.';
        else if (appliedQrUrl) qrStatus.textContent = 'QR preview generated from your link.';
        else qrStatus.textContent = 'Paste a link and press Submit QR to show it on the plaque.';
      }
    }
    function applyQrUrl() {
      if (!qrInput) return;
      const normalized = normalizeQrUrl(qrInput.value);
      appliedQrUrl = normalized;
      if (normalized) qrInput.value = normalized;
      updateQrPreview(); updateDesignData(); updateButton();
    }
    function updateQrLayout() {
      if (stage) stage.setAttribute('data-qr', currentQrMode);
      if (qrPanel) qrPanel.classList.toggle('is-hidden', currentQrMode !== 'with');
      updateQrPreview();
    }

    function findVariant(size) {
      return variants.find(function (v) { return v.size === size && v.available; }) || variants.find(function (v) { return v.available; }) || variants[0] || null;
    }
    function updateVariant() {
      currentVariant = findVariant(currentSize);
      if (currentVariant) {
        currentVariantTitle = currentVariant.title;
        if (variantInput) variantInput.value = currentVariant.id;
        if (selectedTitle) selectedTitle.textContent = currentVariant.title;
        if (selectedPrice) selectedPrice.textContent = currentVariant.priceFormatted || formatMoney(currentVariant.price);
      } else {
        currentVariantTitle = '';
        if (variantInput) variantInput.value = '';
        if (selectedTitle) selectedTitle.textContent = 'Unavailable combination';
        if (selectedPrice) selectedPrice.textContent = '-';
      }
      if (selectedSize) selectedSize.textContent = humanRecordSize(currentSize);
      if (sizeProperty) sizeProperty.value = humanRecordSize(currentSize);
      updateDesignData(); updateButton();
    }

    function updatePreviewText() {
      setText('[data-cd-record-title]', getField('title'), 'Our Song');
      setText('[data-cd-record-subtitle]', getField('subtitle'), 'Your names or special message');
      setText('[data-cd-record-left]', getField('left'), '00:00');
      setText('[data-cd-record-right]', getField('right'), '∞');
      updateRightClass(); updateDesignData(); updateButton();
    }

    function applyCrystalLayout() {
      if (!stage || !photoWrap) return;
      const spec = crystalVariantSpec(currentVariant || { shape: currentShape, title: '' });
      const scale = spec.scale || 1;
      stage.style.setProperty('--cd-crystal-product-scale', String(scale));
      stage.setAttribute('data-size', (spec.label || '').toLowerCase());
      const cx = currentShape === 'rect' ? 50.6 : 50.0;
      const cy = currentShape === 'rect' ? 43.0 : 43.0;
      let w, h, top;
      if (currentShape === 'rect') {
        h = 55 * scale;
        w = h * (spec.ratio || .67);
        top = 15.5 + (1 - scale) * 8;
      } else {
        w = 72 * scale;
        h = Math.min(64, (w / (spec.ratio || 1.14)));
        top = 13.2 + (1 - scale) * 6;
      }
      const left = cx - w / 2;
      photoWrap.style.left = left.toFixed(2) + '%';
      photoWrap.style.top = top.toFixed(2) + '%';
      photoWrap.style.width = w.toFixed(2) + '%';
      photoWrap.style.height = h.toFixed(2) + '%';
      if (currentShape === 'rect') {
        photoWrap.style.borderRadius = '7px';
      } else {
        photoWrap.style.borderRadius = '';
      }
    }

    function updateDesignData() {
      if (!designInput) return;
      const data = {
        product_type: 'vinyl_record_photo_plaque', variant_title: currentVariantTitle,
        variant_id: currentVariant ? currentVariant.id : '', plaque_size: currentSize,
        qr_option: currentQrMode === 'with' ? 'with_qr' : 'without_qr', qr_url: currentQrMode === 'with' ? (appliedQrUrl || getField('qr')) : '',
        text_color: currentColor, main_title: getField('title'), subtitle: getField('subtitle'), left_time: getField('left'), right_time: getField('right'), notes: getField('notes'),
        preview_type: 'vinyl_record_blank_mockup_v40', photo_zoom: recordZoom, photo_x: Math.round(recordX), photo_y: Math.round(recordY),
        brightness: Math.round(recordAdjustments.brightness), contrast: Math.round(recordAdjustments.contrast), saturation: Math.round(recordAdjustments.saturation), grayscale: Math.round(recordAdjustments.grayscale),
        photo_style: 'Brightness ' + Math.round(recordAdjustments.brightness) + '%, Contrast ' + Math.round(recordAdjustments.contrast) + '%, Color ' + Math.round(recordAdjustments.saturation) + '%, Black & white ' + Math.round(recordAdjustments.grayscale) + '%', ai_ready: true
      };
      designInput.value = JSON.stringify(data);
    }

    function updateButton() {
      const hasPhoto = !!selectedFile || (fileInput && fileInput.files && fileInput.files[0]);
      const ready = hasPhoto && !!(variantInput && variantInput.value) && !!getField('title') && (!rights || rights.checked) && (currentQrMode !== 'with' || !!appliedQrUrl);
      if (addButton) addButton.disabled = !ready;
      if (status) {
        if (!hasPhoto) status.textContent = 'Upload a photo to continue.';
        else if (!(variantInput && variantInput.value)) status.textContent = 'This size is unavailable.';
        else if (!getField('title')) status.textContent = 'Add a main title or song name to continue.';
        else if (currentQrMode === 'with' && !appliedQrUrl) status.textContent = 'Paste your QR link and press Submit QR, or choose Without QR.';
        else if (rights && !rights.checked) status.textContent = 'Confirm image rights to continue.';
        else status.textContent = 'Ready to add to cart.';
      }
    }

    function applyPhotoTransform() {
      if (!previewImage) return;
      syncAdjustmentInputs();
      previewImage.style.setProperty('--cd-record-photo-zoom', String(recordZoom));
      previewImage.style.setProperty('--cd-record-photo-x', recordX + 'px');
      previewImage.style.setProperty('--cd-record-photo-y', recordY + 'px');
      previewImage.style.filter = currentFilter();
      updateDesignData();
    }

    function loadDataUrl(dataUrl) {
      if (!previewImage) return;
      previewImage.onload = function () { imageLoaded = true; recordZoom = 1; recordX = 0; recordY = 0; if (zoomInput) zoomInput.value = 100; applyPhotoTransform(); if (placeholder) placeholder.style.display = 'none'; previewImage.classList.add('is-loaded'); updateButton(); };
      previewImage.src = dataUrl;
    }
    function loadFile(file) {
      if (!file) return;
      selectedFile = file;
      if (uploadLabel) uploadLabel.textContent = file.name || 'Photo uploaded';
      fileToDataUrl(file).then(function (dataUrl) { loadDataUrl(dataUrl); writeState({ originalPreviewDataUrl: dataUrl }); });
      updateButton();
    }
    document.addEventListener('creodise:master-photo', function (event) { if (event.detail && event.detail.file) { selectedFile = event.detail.file; syncFileToInput(); } else if (cdMasterFile) { selectedFile = cdMasterFile; syncFileToInput(); } if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl); if (uploadLabel && selectedFile) uploadLabel.textContent = selectedFile.name || 'Photo uploaded'; updateButton(); });
    document.addEventListener('creodise:record-photo-url', function (event) { if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl); });
    if (fileInput) fileInput.addEventListener('change', function () { loadFile(fileInput.files && fileInput.files[0]); });

    qrRadios.forEach(function (radio) { radio.addEventListener('change', function () { if (!radio.checked) return; currentQrMode = radio.getAttribute('data-cd-record-qr-mode') || 'no'; if (currentQrMode !== 'with') appliedQrUrl = ''; updateQrLayout(); updateDesignData(); updateButton(); }); });
    if (qrApply) qrApply.addEventListener('click', applyQrUrl);
    if (qrInput) qrInput.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); applyQrUrl(); } });
    fields.forEach(function (field) { field.addEventListener('input', function () { if (field === qrInput && appliedQrUrl && normalizeQrUrl(field.value) !== appliedQrUrl) { appliedQrUrl = ''; updateQrPreview(); } updatePreviewText(); }); });
    colorRadios.forEach(function (radio) { radio.addEventListener('change', function () { if (!radio.checked) return; currentColor = radio.getAttribute('data-cd-record-color') || 'white'; if (stage) stage.setAttribute('data-color', currentColor); updateDesignData(); }); });
    sizeRadios.forEach(function (radio) { radio.addEventListener('change', function () { if (!radio.checked) return; currentSize = radio.value || '6x6'; updateVariant(); }); });
    if (zoomInput) zoomInput.addEventListener('input', function () { recordZoom = clamp(Number(zoomInput.value || 100) / 100, 1, 2.2); applyPhotoTransform(); });
    if (centerButton) centerButton.addEventListener('click', function () { recordX = 0; recordY = 0; recordZoom = 1; if (zoomInput) zoomInput.value = 100; applyPhotoTransform(); });
    Object.keys(recordAdjustmentInputs).forEach(function (key) { const input = recordAdjustmentInputs[key]; if (input) input.addEventListener('input', function () { setAdjustment(key, input.value); }); });
    filterButtons.forEach(function (button) { button.addEventListener('click', function () { setFilterPreset(button.getAttribute('data-cd-record-filter-preset') || 'natural'); }); });
    if (photoWrap) {
      photoWrap.addEventListener('pointerdown', function (event) { if (!imageLoaded) return; dragging = true; photoWrap.classList.add('is-dragging'); dragStartX = event.clientX; dragStartY = event.clientY; startX = recordX; startY = recordY; if (photoWrap.setPointerCapture) photoWrap.setPointerCapture(event.pointerId); });
      photoWrap.addEventListener('pointermove', function (event) { if (!dragging) return; recordX = startX + (event.clientX - dragStartX); recordY = startY + (event.clientY - dragStartY); applyPhotoTransform(); });
      photoWrap.addEventListener('pointerup', function (event) { dragging = false; photoWrap.classList.remove('is-dragging'); if (photoWrap.releasePointerCapture) photoWrap.releasePointerCapture(event.pointerId); });
      photoWrap.addEventListener('pointercancel', function () { dragging = false; photoWrap.classList.remove('is-dragging'); });
    }
    if (rights) rights.addEventListener('change', updateButton);

    function attachFileToInput(input, blob, filename) {
      if (!blob || !input || !window.DataTransfer || !window.File) return false;
      try { const file = new File([blob], filename, { type: 'image/jpeg' }); const dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; return true; } catch (e) { return false; }
    }
    function drawCoverImage(ctx, img, x, y, w, h, useTransform) {
      const naturalW = img.naturalWidth || w, naturalH = img.naturalHeight || h;
      const baseScale = Math.max(w / naturalW, h / naturalH), scale = baseScale * (useTransform ? recordZoom : 1);
      const drawW = naturalW * scale, drawH = naturalH * scale;
      const factor = w / Math.max(1, (photoWrap && photoWrap.clientWidth) || w);
      const dx = useTransform ? recordX * factor : 0, dy = useTransform ? recordY * factor : 0;
      ctx.save(); if ('filter' in ctx) ctx.filter = currentFilter();
      ctx.drawImage(img, x + (w - drawW) / 2 + dx, y + (h - drawH) / 2 + dy, drawW, drawH);
      ctx.restore(); if ('filter' in ctx) ctx.filter = 'none';
    }
    function makeCroppedBlob() {
      return new Promise(function (resolve) { if (!previewImage || !imageLoaded) return resolve(null); const canvas = document.createElement('canvas'); canvas.width = 1200; canvas.height = 1200; const ctx = canvas.getContext('2d'); ctx.fillStyle = '#f6f2ec'; ctx.fillRect(0,0,1200,1200); drawCoverImage(ctx, previewImage, 0, 0, 1200, 1200, true); canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.92); });
    }
    function makePreviewBlob() {
      return new Promise(function (resolve) {
        if (!previewImage || !imageLoaded) return resolve(null);
        const canvas = document.createElement('canvas');
        canvas.width = 1200; canvas.height = 1200;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#d7c9b6'; ctx.fillRect(0,0,1200,1200);
        ctx.fillStyle = '#050505';
        ctx.beginPath(); ctx.ellipse(600, 525, 430, 350, 0, 0, Math.PI*2); ctx.fill();
        ctx.save(); ctx.beginPath(); ctx.arc(600, 576, 206, 0, Math.PI*2); ctx.clip();
        drawCoverImage(ctx, previewImage, 394,370,412,412,true);
        ctx.restore();
        const color = '#ffffff';
        ctx.fillStyle = color; ctx.textAlign = 'left';
        const hasQr = currentQrMode === 'with';
        const startX = 394;
        const textX = hasQr ? 462 : 394;
        const lineEnd = 806;
        const width = hasQr ? 292 : 370;
        if (hasQr) { ctx.fillStyle='#fff'; ctx.fillRect(394,818,56,56); }
        ctx.fillStyle = color; ctx.font='430 18px Arial'; ctx.fillText(getField('title') || 'Our Song', textX, 840, width);
        ctx.font='340 11px Arial'; ctx.fillText(getField('subtitle') || 'Your names or special message', textX, 858, width);
        ctx.strokeStyle=color; ctx.lineWidth=1.45; ctx.beginPath(); ctx.moveTo(startX,892); ctx.lineTo(lineEnd,892); ctx.stroke();
        ctx.beginPath(); ctx.arc(startX + (lineEnd-startX)*0.22,892,3.2,0,Math.PI*2); ctx.fill();
        ctx.font='340 10px Arial'; ctx.fillText(getField('left') || '00:00', startX, 910);
        ctx.textAlign='right'; const rt=getField('right') || '∞'; ctx.font=rt==='∞'?'430 14px Arial':'340 10px Arial'; ctx.fillText(rt, lineEnd, 910);
        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.86);
      });
    }
    if (form) {
      form.setAttribute('novalidate','novalidate');
      form.addEventListener('submit', function (event) {
        if (form.getAttribute('data-cd-ready-submit') === 'true') return;
        event.preventDefault(); syncFileToInput(); updateDesignData();
        if (!selectedFile && !(fileInput && fileInput.files && fileInput.files[0])) { if (status) status.textContent='Please upload a photo before adding to cart.'; return; }
        if (!variantInput || !variantInput.value) { if (status) status.textContent='Please choose a plaque size.'; return; }
        if (!getField('title')) { if (status) status.textContent='Please add a main title or song name.'; return; }
        if (currentQrMode === 'with' && !appliedQrUrl) { if (status) status.textContent='Please paste your QR link and press Submit QR, or choose Without QR.'; return; }
        if (rights && !rights.checked) { if (status) status.textContent='Please confirm you have the right to use this image.'; return; }
        if (addButton) { addButton.disabled=true; addButton.textContent='Preparing files...'; }
        if (status) status.textContent='Preparing plaque preview...';
        Promise.all([makeCroppedBlob(), makePreviewBlob()]).then(function (blobs) { attachFileToInput(croppedFileInput, blobs[0], 'creodise-record-edited-photo.jpg'); attachFileToInput(previewFileInput, blobs[1], 'creodise-record-preview-reference.jpg'); form.setAttribute('data-cd-ready-submit','true'); if (status) status.textContent='Adding to cart...'; if (addButton) addButton.textContent='Adding to cart...'; form.submit(); }).catch(function () { form.setAttribute('data-cd-ready-submit','true'); form.submit(); });
      });
    }
    syncAdjustmentInputs(); const stored = readState(); if (stored.originalPreviewDataUrl) loadDataUrl(stored.originalPreviewDataUrl); updateQrLayout(); updateVariant(); updatePreviewText(); updateButton();
  }


  function inferGlassSize(title) {
    const text = String(title || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '');
    if (text.indexOf('27x43') >= 0 || text.indexOf('70x110') >= 0) return '27x43';
    if (text.indexOf('24x36') >= 0 || text.indexOf('60x90') >= 0) return '24x36';
    if (text.indexOf('20x28') >= 0 || text.indexOf('50x70') >= 0) return '20x28';
    if (text.indexOf('14x20') >= 0 || text.indexOf('35x50') >= 0) return '14x20';
    if (text.indexOf('10x14') >= 0 || text.indexOf('25x35') >= 0) return '10x14';
    return '10x14';
  }

  function glassSizeLabel(size) {
    if (size === '27x43') return '27 × 43 in';
    if (size === '24x36') return '24 × 36 in';
    if (size === '20x28') return '20 × 28 in';
    if (size === '14x20') return '14 × 20 in';
    return '10 × 14 in';
  }

  function glassAspect(size) {
    if (size === '27x43') return 43 / 27;
    if (size === '24x36') return 36 / 24;
    if (size === '20x28') return 28 / 20;
    if (size === '14x20') return 20 / 14;
    return 14 / 10;
  }

  function initGlassBuilder(root) {
    const form = root.querySelector('[data-cd-glass-form]');
    const fileInput = root.querySelector('[data-cd-glass-direct-upload]');
    const editedInput = root.querySelector('[data-cd-glass-edited-upload]');
    const previewInput = root.querySelector('[data-cd-glass-preview-upload]');
    const uploadLabel = root.querySelector('[data-cd-glass-upload-label]');
    const previewImage = root.querySelector('[data-cd-glass-image]');
    const placeholder = root.querySelector('[data-cd-glass-placeholder]');
    const photoWrap = root.querySelector('[data-cd-glass-photo-wrap]');
    const stage = root.querySelector('[data-cd-glass-stage]');
    const variantInput = root.querySelector('[data-cd-glass-variant-input]');
    const variantDataEls = Array.from(root.querySelectorAll('[data-cd-glass-variant-data]'));
    const sizeRadios = root.querySelectorAll('[data-cd-glass-size-choice]');
    const sizeProperty = root.querySelector('[data-cd-glass-size-property]');
    const designInput = root.querySelector('[data-cd-glass-design-data]');
    const selectedSize = root.querySelector('[data-cd-glass-selected-size]');
    const selectedPrice = root.querySelector('[data-cd-glass-selected-price]');
    const addButton = root.querySelector('[data-cd-glass-add]');
    const status = root.querySelector('[data-cd-glass-status]');
    const rights = root.querySelector('[data-cd-glass-rights]');
    const zoomInput = root.querySelector('[data-cd-glass-zoom]');
    const zoomValue = root.querySelector('[data-cd-glass-zoom-value]');
    const centerButton = root.querySelector('[data-cd-glass-center]');
    const zoomIn = root.querySelector('[data-cd-glass-zoom-in]');
    const zoomOut = root.querySelector('[data-cd-glass-zoom-out]');
    const rotateLeft = root.querySelector('[data-cd-glass-rotate-left]');
    const rotateRight = root.querySelector('[data-cd-glass-rotate-right]');

    if (!form || !previewImage) return;

    const variants = variantDataEls.map(function (el) {
      return {
        id: el.getAttribute('data-id') || '',
        title: el.getAttribute('data-title') || '',
        price: el.getAttribute('data-price') || '',
        priceFormatted: el.getAttribute('data-price-formatted') || '',
        size: el.getAttribute('data-size') || inferGlassSize(el.getAttribute('data-title')),
        available: el.getAttribute('data-available') === 'true',
        productTitle: el.getAttribute('data-product-title') || '',
        productHandle: el.getAttribute('data-product-handle') || ''
      };
    });

    let selectedFile = null;
    let imageLoaded = false;
    let currentSize = '10x14';
    let currentType = 'Artwork';
    let currentVariant = null;
    let glassZoom = 1;
    let glassX = 0;
    let glassY = 0;
    let glassRotate = 0;
    let dragging = false, dragStartX = 0, dragStartY = 0, startX = 0, startY = 0;

    function syncFileToInput() {
      if (!selectedFile || !fileInput || !window.DataTransfer) return;
      try { const dt = new DataTransfer(); dt.items.add(selectedFile); fileInput.files = dt.files; } catch (e) {}
    }

    function findVariant(size) {
      return variants.find(function (v) { return v.size === size && v.available; }) || variants.find(function (v) { return v.available; }) || variants[0] || null;
    }

    function updateVariant() {
      currentVariant = findVariant(currentSize);
      if (currentVariant) {
        if (variantInput) variantInput.value = currentVariant.id;
        if (selectedPrice) selectedPrice.textContent = currentVariant.priceFormatted || formatMoney(currentVariant.price);
      }
      if (selectedSize) selectedSize.textContent = glassSizeLabel(currentSize);
      if (sizeProperty) sizeProperty.value = currentSize;
      if (stage) stage.style.setProperty('--cd-glass-print-aspect', glassAspect(currentSize));
      updateDesignData();
      updateButton();
    }

    function applyCrystalLayout() {
      if (!stage || !photoWrap) return;
      const spec = crystalVariantSpec(currentVariant || { shape: currentShape, title: '' });
      const scale = spec.scale || 1;
      stage.style.setProperty('--cd-crystal-product-scale', String(scale));
      stage.setAttribute('data-size', (spec.label || '').toLowerCase());
      const cx = currentShape === 'rect' ? 50.6 : 50.0;
      const cy = currentShape === 'rect' ? 43.0 : 43.0;
      let w, h, top;
      if (currentShape === 'rect') {
        h = 55 * scale;
        w = h * (spec.ratio || .67);
        top = 15.5 + (1 - scale) * 8;
      } else {
        w = 72 * scale;
        h = Math.min(64, (w / (spec.ratio || 1.14)));
        top = 13.2 + (1 - scale) * 6;
      }
      const left = cx - w / 2;
      photoWrap.style.left = left.toFixed(2) + '%';
      photoWrap.style.top = top.toFixed(2) + '%';
      photoWrap.style.width = w.toFixed(2) + '%';
      photoWrap.style.height = h.toFixed(2) + '%';
      if (currentShape === 'rect') {
        photoWrap.style.borderRadius = '7px';
      } else {
        photoWrap.style.borderRadius = '';
      }
    }

    function updateDesignData() {
      if (!designInput) return;
      designInput.value = JSON.stringify({
        builder: 'creodise-glass-v69',
        product_type: 'tempered_glass_wall_art',
        artwork_type: 'Photo or logo',
        size: currentSize,
        aspect_ratio: Number(glassAspect(currentSize).toFixed(4)),
        zoom: Math.round(glassZoom * 100),
        x: Math.round(glassX),
        y: Math.round(glassY),
        rotate: glassRotate
      });
    }

    function updateButton() {
      const hasPhoto = !!selectedFile || (fileInput && fileInput.files && fileInput.files[0]);
      const ready = hasPhoto && !!(variantInput && variantInput.value) && (!rights || rights.checked);
      if (addButton) addButton.disabled = !ready;
      if (status) {
        if (!hasPhoto) status.textContent = 'Upload a photo or logo to continue.';
        else if (!(variantInput && variantInput.value)) status.textContent = 'This glass size is unavailable.';
        else if (rights && !rights.checked) status.textContent = 'Confirm image rights before adding to cart.';
        else status.textContent = 'Ready to add to cart.';
      }
    }

    function applyTransform() {
      if (!previewImage) return;
      if (zoomValue) zoomValue.textContent = Math.round(glassZoom * 100) + '%';
      if (zoomInput) zoomInput.value = Math.round(glassZoom * 100);
      previewImage.style.setProperty('--cd-glass-photo-zoom', String(glassZoom));
      previewImage.style.setProperty('--cd-glass-photo-x', glassX + 'px');
      previewImage.style.setProperty('--cd-glass-photo-y', glassY + 'px');
      previewImage.style.setProperty('--cd-glass-photo-rotate', glassRotate + 'deg');
      updateDesignData();
    }

    function loadDataUrl(dataUrl) {
      if (!previewImage) return;
      previewImage.onload = function () {
        imageLoaded = true;
        glassZoom = 1; glassX = 0; glassY = 0; glassRotate = 0;
        applyTransform();
        if (placeholder) placeholder.style.display = 'none';
        previewImage.classList.add('is-loaded');
        updateButton();
      };
      previewImage.src = dataUrl;
    }

    function loadFile(file) {
      if (!file) return;
      selectedFile = file;
      if (uploadLabel) uploadLabel.textContent = file.name || 'Image uploaded';
      fileToDataUrl(file).then(function (dataUrl) { loadDataUrl(dataUrl); writeState({ originalPreviewDataUrl: dataUrl }); });
      updateButton();
    }

    document.addEventListener('creodise:master-photo', function (event) {
      if (event.detail && event.detail.file) { selectedFile = event.detail.file; syncFileToInput(); }
      else if (cdMasterFile) { selectedFile = cdMasterFile; syncFileToInput(); }
      if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl);
      if (uploadLabel && selectedFile) uploadLabel.textContent = selectedFile.name || 'Image uploaded';
      updateButton();
    });
    document.addEventListener('creodise:glass-photo-url', function (event) { if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl); });
    if (fileInput) fileInput.addEventListener('change', function () { loadFile(fileInput.files && fileInput.files[0]); });

    sizeRadios.forEach(function (radio) { radio.addEventListener('change', function () { if (!radio.checked) return; currentSize = radio.value || '10x14'; updateVariant(); }); });
    if (zoomInput) zoomInput.addEventListener('input', function () { glassZoom = clamp(Number(zoomInput.value || 100) / 100, .7, 2.6); applyTransform(); });
    if (zoomIn) zoomIn.addEventListener('click', function () { glassZoom = clamp(glassZoom + .08, .7, 2.6); applyTransform(); });
    if (zoomOut) zoomOut.addEventListener('click', function () { glassZoom = clamp(glassZoom - .08, .7, 2.6); applyTransform(); });
    if (centerButton) centerButton.addEventListener('click', function () { glassZoom = 1; glassX = 0; glassY = 0; glassRotate = 0; applyTransform(); });
    if (rotateLeft) rotateLeft.addEventListener('click', function () { glassRotate = (glassRotate - 90) % 360; applyTransform(); });
    if (rotateRight) rotateRight.addEventListener('click', function () { glassRotate = (glassRotate + 90) % 360; applyTransform(); });
    if (rights) rights.addEventListener('change', updateButton);

    if (photoWrap) {
      photoWrap.addEventListener('pointerdown', function (event) { if (!imageLoaded) return; dragging = true; photoWrap.classList.add('is-dragging'); dragStartX = event.clientX; dragStartY = event.clientY; startX = glassX; startY = glassY; if (photoWrap.setPointerCapture) photoWrap.setPointerCapture(event.pointerId); });
      photoWrap.addEventListener('pointermove', function (event) { if (!dragging) return; glassX = startX + (event.clientX - dragStartX); glassY = startY + (event.clientY - dragStartY); applyTransform(); });
      photoWrap.addEventListener('pointerup', function (event) { dragging = false; photoWrap.classList.remove('is-dragging'); if (photoWrap.releasePointerCapture) photoWrap.releasePointerCapture(event.pointerId); });
      photoWrap.addEventListener('pointercancel', function () { dragging = false; photoWrap.classList.remove('is-dragging'); });
      photoWrap.addEventListener('wheel', function (event) {
        if (!imageLoaded) return;
        event.preventDefault();
        const delta = event.deltaY > 0 ? -0.06 : 0.06;
        glassZoom = clamp(glassZoom + delta, .7, 2.6);
        applyTransform();
      }, { passive: false });
    }

    function attachFileToInput(input, blob, filename) {
      if (!blob || !input || !window.DataTransfer || !window.File) return false;
      try { const file = new File([blob], filename, { type: 'image/jpeg' }); const dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; return true; } catch (e) { return false; }
    }

    function drawImageInFrame(ctx, img, x, y, w, h, useTransform, fillStyle) {
      ctx.save();
      ctx.fillStyle = fillStyle || '#050505';
      ctx.fillRect(x, y, w, h);
      ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
      const naturalW = img.naturalWidth || w, naturalH = img.naturalHeight || h;
      const scaleContain = Math.min(w / naturalW, h / naturalH);
      const scale = scaleContain * (useTransform ? glassZoom : 1);
      const drawW = naturalW * scale, drawH = naturalH * scale;
      const factor = w / Math.max(1, (photoWrap && photoWrap.clientWidth) || w);
      const dx = useTransform ? glassX * factor : 0, dy = useTransform ? glassY * factor : 0;
      ctx.translate(x + w / 2 + dx, y + h / 2 + dy);
      ctx.rotate((useTransform ? glassRotate : 0) * Math.PI / 180);
      ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
      ctx.restore();
    }

    function makeEditedBlob() {
      return new Promise(function (resolve) {
        if (!previewImage || !imageLoaded) return resolve(null);
        const aspect = glassAspect(currentSize);
        const canvas = document.createElement('canvas');
        canvas.width = 1600; canvas.height = Math.round(1600 / aspect);
        const ctx = canvas.getContext('2d');
        drawImageInFrame(ctx, previewImage, 0, 0, canvas.width, canvas.height, true, '#050505');
        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.92);
      });
    }

    function makePreviewBlob() {
      return new Promise(function (resolve) {
        if (!previewImage || !imageLoaded) return resolve(null);
        const canvas = document.createElement('canvas'); canvas.width = 1400; canvas.height = 900;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#f7f5f1'; ctx.fillRect(0,0,1400,900);
        const aspect = glassAspect(currentSize);
        const maxW = 1180, maxH = 720;
        let w = maxW;
        let h = Math.round(w / aspect);
        if (h > maxH) { h = maxH; w = Math.round(h * aspect); }
        const x = Math.round((1400 - w) / 2);
        const y = Math.round((900 - h) / 2);
        ctx.save();
        ctx.shadowColor = 'rgba(0,0,0,.34)'; ctx.shadowBlur = 34; ctx.shadowOffsetX = 18; ctx.shadowOffsetY = 26;
        ctx.fillStyle = '#070707'; ctx.fillRect(x, y, w, h);
        ctx.restore();
        drawImageInFrame(ctx, previewImage, x, y, w, h, true, '#050505');
        ctx.save();
        ctx.globalAlpha = .16; ctx.fillStyle = '#000'; ctx.fillRect(x, y, w, h); ctx.restore();
        const gloss = ctx.createLinearGradient(x, y, x + w, y + h);
        gloss.addColorStop(0,'rgba(255,255,255,.24)');
        gloss.addColorStop(.16,'rgba(255,255,255,.08)');
        gloss.addColorStop(.36,'rgba(255,255,255,0)');
        gloss.addColorStop(.72,'rgba(255,255,255,0)');
        gloss.addColorStop(1,'rgba(255,255,255,.12)');
        ctx.fillStyle = gloss; ctx.fillRect(x, y, w, h);
        const shine = ctx.createLinearGradient(x + w * .35, y, x + w * .70, y + h);
        shine.addColorStop(0,'rgba(255,255,255,0)');
        shine.addColorStop(.48,'rgba(255,255,255,.13)');
        shine.addColorStop(.55,'rgba(255,255,255,.06)');
        shine.addColorStop(1,'rgba(255,255,255,0)');
        ctx.fillStyle = shine; ctx.fillRect(x, y, w, h);
        ctx.strokeStyle = 'rgba(255,255,255,.42)'; ctx.lineWidth = 3; ctx.strokeRect(x + 1.5, y + 1.5, w - 3, h - 3);
        ctx.strokeStyle = 'rgba(0,0,0,.36)'; ctx.lineWidth = 10; ctx.beginPath(); ctx.moveTo(x+w+5,y+7); ctx.lineTo(x+w+5,y+h+7); ctx.lineTo(x+7,y+h+7); ctx.stroke();
        ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(x+4,y+5); ctx.lineTo(x+w-6,y+5); ctx.stroke();
        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.86);
      });
    }

    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (form.getAttribute('data-cd-ready-submit') === 'true') return;
        event.preventDefault(); syncFileToInput(); updateDesignData();
        if (!selectedFile && !(fileInput && fileInput.files && fileInput.files[0])) { if (status) status.textContent = 'Please upload a photo or logo first.'; return; }
        if (!variantInput || !variantInput.value) { if (status) status.textContent = 'Please choose a glass size.'; return; }
        if (rights && !rights.checked) { if (status) status.textContent = 'Please confirm you have the right to use this image.'; return; }
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Preparing files...'; }
        if (status) status.textContent = 'Preparing glass preview...';
        Promise.all([makeEditedBlob(), makePreviewBlob()]).then(function (blobs) {
          attachFileToInput(editedInput, blobs[0], 'creodise-glass-edited-production-image.jpg');
          attachFileToInput(previewInput, blobs[1], 'creodise-glass-preview-reference.jpg');
          form.setAttribute('data-cd-ready-submit', 'true');
          if (status) status.textContent = 'Adding to cart...';
          if (addButton) addButton.textContent = 'Adding to cart...';
          form.submit();
        }).catch(function () { form.setAttribute('data-cd-ready-submit', 'true'); form.submit(); });
      });
    }

    const stored = readState();
    if (stored.originalPreviewDataUrl) loadDataUrl(stored.originalPreviewDataUrl);
    updateVariant(); applyTransform(); updateButton();
  }

  function humanCrystalShape(shape) {
    return shape === 'rect' ? 'Rectangle Crystal' : 'Heart Crystal';
  }

  function initCrystalBuilder(root) {
    const form = root.querySelector('[data-cd-crystal-form]');
    const fileInput = root.querySelector('[data-cd-crystal-upload]');
    const originalInput = root.querySelector('[data-cd-crystal-direct-upload]');
    const editedInput = root.querySelector('[data-cd-crystal-edited-upload]');
    const previewInput = root.querySelector('[data-cd-crystal-preview-upload]');
    const uploadLabel = root.querySelector('[data-cd-crystal-upload-label]');
    const previewImage = root.querySelector('[data-cd-crystal-image]');
    const placeholder = root.querySelector('[data-cd-crystal-placeholder]');
    const photoWrap = root.querySelector('[data-cd-crystal-photo-wrap]');
    const stage = root.querySelector('[data-cd-crystal-stage]');
    const variantInput = root.querySelector('[data-cd-crystal-variant-input]');
    const variantDataEls = Array.from(root.querySelectorAll('[data-cd-crystal-variant-data]'));
    const shapeRadios = root.querySelectorAll('[data-cd-crystal-shape-choice]');
    const shapeProperty = root.querySelector('[data-cd-crystal-shape-property]');
    const designInput = root.querySelector('[data-cd-crystal-design-data]');
    const selectedShape = root.querySelector('[data-cd-crystal-selected-shape]');
    const selectedPrice = root.querySelector('[data-cd-crystal-selected-price]');
    const selectedOption = root.querySelector('[data-cd-crystal-selected-option]');
    const variantProperty = root.querySelector('[data-cd-crystal-variant-property]');
    const variantChoiceRadios = Array.from(root.querySelectorAll('[data-cd-crystal-variant-choice]'));
    const variantCards = Array.from(root.querySelectorAll('[data-cd-crystal-variant-card]'));
    const addButton = root.querySelector('[data-cd-crystal-add]');
    const status = root.querySelector('[data-cd-crystal-status]');
    const rights = root.querySelector('[data-cd-crystal-rights]');
    const zoomInput = root.querySelector('[data-cd-crystal-zoom]');
    const zoomValue = root.querySelector('[data-cd-crystal-zoom-value]');
    const centerButton = root.querySelector('[data-cd-crystal-center]');
    const zoomIn = root.querySelector('[data-cd-crystal-zoom-in]');
    const zoomOut = root.querySelector('[data-cd-crystal-zoom-out]');
    const rotateLeft = root.querySelector('[data-cd-crystal-rotate-left]');
    const rotateRight = root.querySelector('[data-cd-crystal-rotate-right]');
    if (!form || !previewImage) return;

    const variants = variantDataEls.map(function (el) {
      return {
        id: el.getAttribute('data-id') || '',
        title: el.getAttribute('data-title') || '',
        price: el.getAttribute('data-price') || '',
        priceFormatted: el.getAttribute('data-price-formatted') || '',
        shape: el.getAttribute('data-shape') || 'heart',
        available: el.getAttribute('data-available') === 'true',
        productTitle: el.getAttribute('data-product-title') || '',
        productHandle: el.getAttribute('data-product-handle') || ''
      };
    });

    let selectedFile = null;
    let imageLoaded = false;
    let currentShape = 'heart';
    let currentVariant = null;
    let crystalZoom = 1;
    let crystalX = 0;
    let crystalY = 0;
    let crystalRotate = 0;
    let dragging = false, dragStartX = 0, dragStartY = 0, startX = 0, startY = 0;

    function syncFileToInput() {
      if (!selectedFile || !originalInput || !window.DataTransfer) return;
      try { const dt = new DataTransfer(); dt.items.add(selectedFile); originalInput.files = dt.files; } catch (e) {}
    }

    function displayCrystalVariantTitle(variant) {
      if (!variant) return '—';
      const title = (variant.title || '').trim();
      if (!title || title === 'Default Title') return humanCrystalShape(variant.shape || currentShape);
      return title;
    }


    function crystalSizeKeyFromTitle(title) {
      const t = String(title || '').toLowerCase();
      if (/(^|[^a-z])xl([^a-z]|$)|extra\s*large/.test(t)) return 'xl';
      if (/large/.test(t)) return 'large';
      if (/medium/.test(t)) return 'medium';
      return 'small';
    }

    function crystalSpecFor(shape, title) {
      const size = crystalSizeKeyFromTitle(title);
      const specs = {
        rect: {
          small:  { label: 'Small',  inches: '1.77 × 1.77 × 2.75 in', cm: '4.5 × 4.5 × 7 cm', people: 'Ideal for 1 to 2 people', ratio: 1.77 / 2.75, scale: .90 },
          medium: { label: 'Medium', inches: '2.36 × 2.36 × 3.15 in', cm: '6 × 6 × 8 cm', people: 'Ideal for 1 to 3 people', ratio: 2.36 / 3.15, scale: .97 },
          large:  { label: 'Large',  inches: '3.14 × 3.14 × 4.13 in', cm: '8 × 8 × 10.5 cm', people: 'Best seller · Ideal for 1 to 4 people', ratio: 3.14 / 4.13, scale: 1.04 },
          xl:     { label: 'XL',     inches: '3.93 × 3.93 × 5.90 in', cm: '10 × 10 × 15 cm', people: 'Ideal for 1 to 5 people', ratio: 3.93 / 5.90, scale: 1.12 }
        },
        heart: {
          small:  { label: 'Small',  inches: '3.14 × 1.57 × 2.75 in', cm: '8 × 4 × 7 cm', people: 'Ideal for 1 to 2 people', ratio: 3.14 / 2.75, scale: .93 },
          medium: { label: 'Medium', inches: '4.01 × 2.32 × 3.50 in', cm: '10.2 × 5.9 × 8.9 cm', people: 'Ideal for 1 to 3 people', ratio: 4.01 / 3.50, scale: 1.00 },
          large:  { label: 'Large',  inches: '4.80 × 2.51 × 4.21 in', cm: '12.2 × 6.4 × 10.7 cm', people: 'Best seller · Ideal for 1 to 4 people', ratio: 4.80 / 4.21, scale: 1.07 }
        }
      };
      const table = specs[shape === 'rect' ? 'rect' : 'heart'];
      return table[size] || table.small;
    }

    function crystalVariantSpec(variant) {
      return crystalSpecFor((variant && variant.shape) || currentShape, variant ? variant.title : '');
    }

    function findVariantById(id) {
      return variants.find(function (v) { return String(v.id) === String(id); }) || null;
    }

    function findVariant(shape) {
      const checked = variantChoiceRadios.find(function (radio) {
        return radio.checked && radio.getAttribute('data-shape') === shape && !radio.disabled;
      });
      if (checked) return findVariantById(checked.value);
      return variants.find(function (v) { return v.shape === shape && v.available; }) || variants.find(function (v) { return v.available; }) || variants[0] || null;
    }

    function syncVisibleVariantCards() {
      variantCards.forEach(function (card) {
        const visible = card.getAttribute('data-shape') === currentShape;
        card.hidden = !visible;
        card.style.display = visible ? '' : 'none';
      });
      const visibleChecked = variantChoiceRadios.find(function (radio) {
        return radio.checked && radio.getAttribute('data-shape') === currentShape && !radio.disabled;
      });
      if (!visibleChecked) {
        const firstVisible = variantChoiceRadios.find(function (radio) {
          return radio.getAttribute('data-shape') === currentShape && !radio.disabled;
        });
        if (firstVisible) firstVisible.checked = true;
      }
    }

    function updateVariant() {
      syncVisibleVariantCards();
      currentVariant = findVariant(currentShape);
      if (currentVariant) {
        if (variantInput) variantInput.value = currentVariant.id;
        if (selectedPrice) selectedPrice.textContent = currentVariant.priceFormatted || formatMoney(currentVariant.price);
        if (selectedOption) selectedOption.textContent = displayCrystalVariantTitle(currentVariant);
        if (variantProperty) variantProperty.value = displayCrystalVariantTitle(currentVariant);
        variantChoiceRadios.forEach(function (radio) {
          radio.checked = String(radio.value) === String(currentVariant.id);
        });
      } else {
        if (variantInput) variantInput.value = '';
        if (selectedPrice) selectedPrice.textContent = '—';
        if (selectedOption) selectedOption.textContent = '—';
        if (variantProperty) variantProperty.value = '';
      }
      if (selectedShape) selectedShape.textContent = humanCrystalShape(currentShape);
      if (shapeProperty) shapeProperty.value = humanCrystalShape(currentShape);
      if (stage) stage.setAttribute('data-shape', currentShape);
      applyCrystalLayout();
      updateDesignData(); updateButton();
    }

    function applyCrystalLayout() {
      if (!stage || !photoWrap) return;
      const spec = crystalVariantSpec(currentVariant || { shape: currentShape, title: '' });
      const scale = spec.scale || 1;
      stage.style.setProperty('--cd-crystal-product-scale', String(scale));
      stage.setAttribute('data-size', (spec.label || '').toLowerCase());
      const cx = currentShape === 'rect' ? 50.6 : 50.0;
      const cy = currentShape === 'rect' ? 43.0 : 43.0;
      let w, h, top;
      if (currentShape === 'rect') {
        h = 55 * scale;
        w = h * (spec.ratio || .67);
        top = 15.5 + (1 - scale) * 8;
      } else {
        w = 72 * scale;
        h = Math.min(64, (w / (spec.ratio || 1.14)));
        top = 13.2 + (1 - scale) * 6;
      }
      const left = cx - w / 2;
      photoWrap.style.left = left.toFixed(2) + '%';
      photoWrap.style.top = top.toFixed(2) + '%';
      photoWrap.style.width = w.toFixed(2) + '%';
      photoWrap.style.height = h.toFixed(2) + '%';
      if (currentShape === 'rect') {
        photoWrap.style.borderRadius = '7px';
      } else {
        photoWrap.style.borderRadius = '';
      }
    }

    function updateDesignData() {
      if (!designInput) return;
      designInput.value = JSON.stringify({
        builder: 'creodise-crystal-mvp-v80',
        product_type: '3d_photo_crystal_gift',
        crystal_shape: currentShape,
        shopify_product_handle: currentVariant ? currentVariant.productHandle : '',
        shopify_product_title: currentVariant ? currentVariant.productTitle : '',
        shopify_variant_id: currentVariant ? currentVariant.id : '',
        shopify_variant_title: currentVariant ? displayCrystalVariantTitle(currentVariant) : '',
        crystal_size_label: currentVariant ? crystalVariantSpec(currentVariant).label : '',
        crystal_dimensions_in: currentVariant ? crystalVariantSpec(currentVariant).inches : '',
        crystal_dimensions_cm: currentVariant ? crystalVariantSpec(currentVariant).cm : '',
        crystal_people_guide: currentVariant ? crystalVariantSpec(currentVariant).people : '',
        engraving_ratio: currentVariant ? Number(crystalVariantSpec(currentVariant).ratio.toFixed(3)) : '',
        preview_style: 'grayscale_engraving_mvp_no_background_removal',
        background_removal: 'manual_design_team_after_order',
        zoom: Math.round(crystalZoom * 100),
        x: Math.round(crystalX),
        y: Math.round(crystalY),
        rotate: crystalRotate
      });
    }

    function updateButton() {
      const hasPhoto = !!selectedFile || (fileInput && fileInput.files && fileInput.files[0]) || (originalInput && originalInput.files && originalInput.files[0]);
      const ready = hasPhoto && !!(variantInput && variantInput.value) && (!rights || rights.checked);
      if (addButton) addButton.disabled = !ready;
      if (status) {
        if (!hasPhoto) status.textContent = 'Upload a photo to continue.';
        else if (!(variantInput && variantInput.value)) status.textContent = 'Crystal product or selected shape is unavailable.';
        else if (rights && !rights.checked) status.textContent = 'Confirm image rights before adding to cart.';
        else status.textContent = 'Ready to add to cart.';
      }
    }

    function applyTransform() {
      if (!previewImage) return;
      if (zoomValue) zoomValue.textContent = Math.round(crystalZoom * 100) + '%';
      if (zoomInput) zoomInput.value = Math.round(crystalZoom * 100);
      previewImage.style.setProperty('--cd-crystal-photo-zoom', String(crystalZoom));
      previewImage.style.setProperty('--cd-crystal-photo-x', crystalX + 'px');
      previewImage.style.setProperty('--cd-crystal-photo-y', crystalY + 'px');
      previewImage.style.setProperty('--cd-crystal-photo-rotate', crystalRotate + 'deg');
      updateDesignData();
    }

    function loadDataUrl(dataUrl) {
      if (!previewImage) return;
      previewImage.onload = function () {
        imageLoaded = true;
        crystalZoom = 1; crystalX = 0; crystalY = 0; crystalRotate = 0;
        applyTransform();
        if (placeholder) placeholder.style.display = 'none';
        if (stage) stage.classList.add('has-image');
        previewImage.classList.add('is-loaded');
        updateButton();
      };
      previewImage.src = dataUrl;
    }

    function loadFile(file) {
      if (!file) return;
      selectedFile = file;
      syncFileToInput();
      if (uploadLabel) uploadLabel.textContent = file.name || 'Photo uploaded';
      fileToDataUrl(file).then(function (dataUrl) { loadDataUrl(dataUrl); writeState({ originalPreviewDataUrl: dataUrl }); });
      updateButton();
    }

    document.addEventListener('creodise:master-photo', function (event) {
      if (event.detail && event.detail.file) { selectedFile = event.detail.file; syncFileToInput(); }
      else if (cdMasterFile) { selectedFile = cdMasterFile; syncFileToInput(); }
      if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl);
      if (uploadLabel && selectedFile) uploadLabel.textContent = selectedFile.name || 'Photo uploaded';
      updateButton();
    });
    document.addEventListener('creodise:crystal-photo-url', function (event) { if (event.detail && event.detail.dataUrl) loadDataUrl(event.detail.dataUrl); });
    if (fileInput) fileInput.addEventListener('change', function () { loadFile(fileInput.files && fileInput.files[0]); });

    shapeRadios.forEach(function (radio) { radio.addEventListener('change', function () { if (!radio.checked) return; currentShape = radio.value || 'heart'; updateVariant(); }); });
    variantChoiceRadios.forEach(function (radio) { radio.addEventListener('change', function () { if (!radio.checked) return; currentVariant = findVariantById(radio.value); updateVariant(); }); });
    if (zoomInput) zoomInput.addEventListener('input', function () { crystalZoom = clamp(Number(zoomInput.value || 100) / 100, .7, 2.4); applyTransform(); });
    if (zoomIn) zoomIn.addEventListener('click', function () { crystalZoom = clamp(crystalZoom + .08, .7, 2.4); applyTransform(); });
    if (zoomOut) zoomOut.addEventListener('click', function () { crystalZoom = clamp(crystalZoom - .08, .7, 2.4); applyTransform(); });
    if (centerButton) centerButton.addEventListener('click', function () { crystalZoom = 1; crystalX = 0; crystalY = 0; crystalRotate = 0; applyTransform(); });
    if (rotateLeft) rotateLeft.addEventListener('click', function () { crystalRotate = (crystalRotate - 90) % 360; applyTransform(); });
    if (rotateRight) rotateRight.addEventListener('click', function () { crystalRotate = (crystalRotate + 90) % 360; applyTransform(); });
    if (rights) rights.addEventListener('change', updateButton);

    if (photoWrap) {
      photoWrap.addEventListener('pointerdown', function (event) { if (!imageLoaded) return; dragging = true; photoWrap.classList.add('is-dragging'); dragStartX = event.clientX; dragStartY = event.clientY; startX = crystalX; startY = crystalY; if (photoWrap.setPointerCapture) photoWrap.setPointerCapture(event.pointerId); });
      photoWrap.addEventListener('pointermove', function (event) { if (!dragging) return; crystalX = startX + (event.clientX - dragStartX); crystalY = startY + (event.clientY - dragStartY); applyTransform(); });
      photoWrap.addEventListener('pointerup', function (event) { dragging = false; photoWrap.classList.remove('is-dragging'); if (photoWrap.releasePointerCapture) photoWrap.releasePointerCapture(event.pointerId); });
      photoWrap.addEventListener('pointercancel', function () { dragging = false; photoWrap.classList.remove('is-dragging'); });
      photoWrap.addEventListener('wheel', function (event) {
        if (!imageLoaded) return;
        event.preventDefault();
        const delta = event.deltaY > 0 ? -0.06 : 0.06;
        crystalZoom = clamp(crystalZoom + delta, .7, 2.4);
        applyTransform();
      }, { passive: false });
    }

    function attachFileToInput(input, blob, filename, type) {
      if (!blob || !input || !window.DataTransfer || !window.File) return false;
      try { const file = new File([blob], filename, { type: type || 'image/jpeg' }); const dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; return true; } catch (e) { return false; }
    }

    function frameSpec(shape, canvasW, canvasH) {
      const spec = crystalSpecFor(shape, currentVariant ? currentVariant.title : '');
      const scale = spec.scale || 1;
      if (shape === 'rect') {
        const h = canvasH * .55 * scale;
        const w = h * (spec.ratio || .67);
        const x = canvasW * .506 - w / 2;
        const y = canvasH * (.155 + (1 - scale) * .08);
        return { x: x, y: y, w: w, h: h, shape: 'rect' };
      }
      const w = canvasW * .72 * scale;
      const h = Math.min(canvasH * .64, w / (spec.ratio || 1.14));
      const x = canvasW * .50 - w / 2;
      const y = canvasH * (.132 + (1 - scale) * .06);
      return { x: x, y: y, w: w, h: h, shape: 'heart' };
    }

    function clipHeart(ctx, x, y, w, h) {
      ctx.beginPath();
      ctx.moveTo(x + w * .50, y + h * .97);
      ctx.bezierCurveTo(x + w * .05, y + h * .70, x + w * .00, y + h * .30, x + w * .23, y + h * .10);
      ctx.bezierCurveTo(x + w * .39, y - h * .04, x + w * .50, y + h * .16, x + w * .50, y + h * .16);
      ctx.bezierCurveTo(x + w * .50, y + h * .16, x + w * .61, y - h * .04, x + w * .77, y + h * .10);
      ctx.bezierCurveTo(x + w * 1.00, y + h * .30, x + w * .95, y + h * .70, x + w * .50, y + h * .97);
      ctx.closePath();
    }

    function drawPhoto(ctx, img, spec, useTransform) {
      ctx.save();
      if (spec.shape === 'heart') clipHeart(ctx, spec.x, spec.y, spec.w, spec.h);
      else { ctx.beginPath(); ctx.rect(spec.x, spec.y, spec.w, spec.h); ctx.closePath(); }
      ctx.clip();
      const naturalW = img.naturalWidth || spec.w, naturalH = img.naturalHeight || spec.h;
      const baseScale = Math.max(spec.w / naturalW, spec.h / naturalH);
      const scale = baseScale * (useTransform ? crystalZoom : 1);
      const drawW = naturalW * scale, drawH = naturalH * scale;
      const factor = spec.w / Math.max(1, (photoWrap && photoWrap.clientWidth) || spec.w);
      const dx = useTransform ? crystalX * factor : 0, dy = useTransform ? crystalY * factor : 0;
      ctx.translate(spec.x + spec.w / 2 + dx, spec.y + spec.h / 2 + dy);
      ctx.rotate((useTransform ? crystalRotate : 0) * Math.PI / 180);
      if ('filter' in ctx) ctx.filter = 'grayscale(1) contrast(1.25) brightness(1.05) sepia(.12)';
      ctx.globalAlpha = .74;
      ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
      ctx.restore();
    }

    function loadCanvasImage(src) {
      return new Promise(function (resolve, reject) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = reject;
        img.src = src;
      });
    }

    function makeEditedBlob() {
      return new Promise(function (resolve) {
        if (!previewImage || !imageLoaded) return resolve(null);
        const spec = crystalVariantSpec(currentVariant || { shape: currentShape, title: '' });
        const ratio = spec.ratio || (currentShape === 'rect' ? .70 : 1.14);
        const canvas = document.createElement('canvas');
        if (currentShape === 'rect') { canvas.width = 1200; canvas.height = Math.round(1200 / ratio); }
        else { canvas.width = 1400; canvas.height = Math.round(1400 / ratio); }
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#f7f7f7'; ctx.fillRect(0, 0, canvas.width, canvas.height);
        drawPhoto(ctx, previewImage, { x: 0, y: 0, w: canvas.width, h: canvas.height, shape: currentShape === 'heart' ? 'heart' : 'rect' }, true);
        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.9);
      });
    }

    function makePreviewBlob() {
      return new Promise(function (resolve) {
        if (!previewImage || !imageLoaded || !stage) return resolve(null);
        const mockupSrc = currentShape === 'rect' ? stage.getAttribute('data-cd-crystal-rect-src') : stage.getAttribute('data-cd-crystal-heart-src');
        loadCanvasImage(mockupSrc).then(function (mockup) {
          const canvas = document.createElement('canvas'); canvas.width = 1200; canvas.height = 1200;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(mockup, 0, 0, canvas.width, canvas.height);
          drawPhoto(ctx, previewImage, frameSpec(currentShape, canvas.width, canvas.height), true);
          ctx.save();
          ctx.globalCompositeOperation = 'screen';
          ctx.globalAlpha = .18;
          const g = ctx.createRadialGradient(600, 800, 10, 600, 800, 520);
          g.addColorStop(0, 'rgba(255,255,255,.60)');
          g.addColorStop(.45, 'rgba(255,255,255,.12)');
          g.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.fillStyle = g; ctx.fillRect(0,0,1200,1200);
          ctx.restore();
          canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.86);
        }).catch(function () { resolve(null); });
      });
    }

    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (form.getAttribute('data-cd-ready-submit') === 'true') return;
        event.preventDefault(); syncFileToInput(); updateDesignData();
        if (!selectedFile && !(originalInput && originalInput.files && originalInput.files[0])) { if (status) status.textContent = 'Please upload a photo first.'; return; }
        if (!variantInput || !variantInput.value) { if (status) status.textContent = 'Please choose an available crystal shape.'; return; }
        if (rights && !rights.checked) { if (status) status.textContent = 'Please confirm you have the right to use this image.'; return; }
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Preparing files...'; }
        if (status) status.textContent = 'Preparing crystal preview...';
        Promise.all([makeEditedBlob(), makePreviewBlob()]).then(function (blobs) {
          attachFileToInput(editedInput, blobs[0], 'creodise-crystal-edited-engraving-image.jpg', 'image/jpeg');
          attachFileToInput(previewInput, blobs[1], 'creodise-crystal-preview-reference.jpg', 'image/jpeg');
          form.setAttribute('data-cd-ready-submit', 'true');
          if (status) status.textContent = 'Adding to cart...';
          if (addButton) addButton.textContent = 'Adding to cart...';
          form.submit();
        }).catch(function () { form.setAttribute('data-cd-ready-submit', 'true'); form.submit(); });
      });
    }

    const stored = readState();
    if (stored.originalPreviewDataUrl) loadDataUrl(stored.originalPreviewDataUrl);
    updateVariant(); applyTransform(); updateButton();
  }

  function init() {
    document.querySelectorAll('[data-cd-custom-gift-builder]').forEach(initGenericBuilder);
    document.querySelectorAll('[data-cd-puzzle-builder]').forEach(initPuzzleBuilder);
    document.querySelectorAll('[data-cd-song-builder]').forEach(initSongBuilder);
    document.querySelectorAll('[data-cd-record-builder]').forEach(initRecordBuilder);
    document.querySelectorAll('[data-cd-glass-builder]').forEach(initGlassBuilder);
    document.querySelectorAll('[data-cd-crystal-builder]').forEach(initCrystalBuilder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* v57: Mobile step wizard layer. Desktop behavior is untouched. */
(function () {
  'use strict';

  function closestStep(el) {
    return el ? el.closest('.cd-form-step, .cd-song-editbar, .cd-record__adjust-under, .cd-puzzle-rebuild__tools, .cd-puzzle-rebuild__order, .cd-song__bottom-panel, .cd-checkout-step') : null;
  }

  function markPanel(el, step) {
    if (!el || el.getAttribute('data-cd-mobile-step')) return;
    el.classList.add('cd-mobile-step-panel');
    el.setAttribute('data-cd-mobile-step', step);
  }

  function markSelector(root, selector, step) {
    root.querySelectorAll(selector).forEach(function (el) { markPanel(el, step); });
  }

  function createTabs(root, previewEl, tabs, anchorEl) {
    if (!root || root.querySelector('.cd-mobile-tabs')) return null;
    var nav = document.createElement('div');
    nav.className = 'cd-mobile-tabs';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Customizer steps');

    tabs.forEach(function (tab, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cd-mobile-tab';
      button.setAttribute('data-cd-mobile-tab', tab.key);
      button.setAttribute('role', 'tab');
      button.innerHTML = '<span>' + (index + 1) + '</span><strong>' + tab.label + '</strong>';
      nav.appendChild(button);
    });

    var anchor = anchorEl || previewEl;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(nav, anchor.nextSibling);
    else if (previewEl && previewEl.parentNode) previewEl.parentNode.insertBefore(nav, previewEl.nextSibling);
    return nav;
  }

  function activateStep(root, step) {
    root.setAttribute('data-cd-mobile-active', step);
    root.querySelectorAll('.cd-mobile-tab').forEach(function (button) {
      var active = button.getAttribute('data-cd-mobile-tab') === step;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('.cd-mobile-step-panel').forEach(function (panel) {
      var activePanel = panel.getAttribute('data-cd-mobile-step') === step;
      panel.classList.toggle('is-mobile-active', activePanel);
      if (activePanel) panel.removeAttribute('aria-hidden');
      else panel.setAttribute('aria-hidden', 'true');
    });
  }

  function wireTabs(root, defaultStep) {
    root.querySelectorAll('.cd-mobile-tab').forEach(function (button) {
      button.addEventListener('click', function () {
        activateStep(root, button.getAttribute('data-cd-mobile-tab') || defaultStep);
      });
    });
    activateStep(root, defaultStep);
  }

  function setupPuzzle(root) {
    if (!root || root.classList.contains('cd-mobile-wizard-ready')) return;
    var form = root.querySelector('[data-cd-puzzle-form]');
    var preview = root.querySelector('.cd-puzzle-rebuild__center');
    if (!form || !preview) return;

    root.classList.add('cd-mobile-wizard-ready', 'cd-mobile-wizard--puzzle');
    form.classList.add('cd-mobile-form');
    root.querySelectorAll('.cd-puzzle-rebuild__panel--right').forEach(function (el) { el.classList.add('cd-mobile-shell'); });

    markSelector(root, '.cd-puzzle-rebuild__panel--left', 'photo');
    markSelector(root, '.cd-puzzle-rebuild__tools', 'edit');
    markSelector(root, '.cd-puzzle-rebuild__panel--right > .cd-side-head', 'size');
    markSelector(root, '.cd-puzzle-rebuild__panel--right > [data-cd-variant-grid]', 'size');
    markSelector(root, '.cd-puzzle-rebuild__order', 'review');

    createTabs(root, preview, [
      { key: 'photo', label: 'Photo' },
      { key: 'edit', label: 'Edit' },
      { key: 'size', label: 'Size' },
      { key: 'review', label: 'Review' }
    ], root.querySelector('.cd-puzzle-rebuild__stage-wrap'));
    wireTabs(root, 'photo');
  }

  function setupSong(root) {
    if (!root || root.classList.contains('cd-mobile-wizard-ready')) return;
    var form = root.querySelector('[data-cd-song-form]');
    var preview = root.querySelector('.cd-song__preview-card');
    if (!form || !preview) return;

    root.classList.add('cd-mobile-wizard-ready', 'cd-mobile-wizard--song');
    form.classList.add('cd-mobile-form');
    root.querySelectorAll('.cd-song__side--left, .cd-song__side--right').forEach(function (el) { el.classList.add('cd-mobile-shell'); });

    markPanel(closestStep(root.querySelector('[data-cd-song-upload]')), 'photo');
    markPanel(root.querySelector('.cd-song-editbar'), 'photo');
    markPanel(closestStep(root.querySelector('[data-cd-song-qr-group]')), 'base');
    markPanel(closestStep(root.querySelector('[data-cd-song-stand-group]')), 'base');
    markPanel(closestStep(root.querySelector('[data-cd-song-field="title"]')), 'text');
    markPanel(closestStep(root.querySelector('[data-cd-song-color-group]')), 'text');
    markPanel(closestStep(root.querySelector('[data-cd-song-size-group]')), 'size');
    markPanel(root.querySelector('.cd-song__bottom-panel'), 'review');

    createTabs(root, preview, [
      { key: 'photo', label: 'Photo' },
      { key: 'base', label: 'Base' },
      { key: 'text', label: 'Text' },
      { key: 'size', label: 'Size' },
      { key: 'review', label: 'Review' }
    ], root.querySelector('[data-cd-song-stage]'));
    wireTabs(root, 'photo');
  }

  function setupRecord(root) {
    if (!root || root.classList.contains('cd-mobile-wizard-ready')) return;
    var form = root.querySelector('[data-cd-record-form]');
    var preview = root.querySelector('.cd-record__preview-card');
    if (!form || !preview) return;

    root.classList.add('cd-mobile-wizard-ready', 'cd-mobile-wizard--record');
    form.classList.add('cd-mobile-form');
    root.querySelectorAll('.cd-record__side--left, .cd-record__side--right').forEach(function (el) { el.classList.add('cd-mobile-shell'); });

    markPanel(closestStep(root.querySelector('[data-cd-record-upload]')), 'photo');
    markPanel(root.querySelector('.cd-record__adjust-under'), 'photo');
    markPanel(closestStep(root.querySelector('[data-cd-record-qr-group]')), 'qr');
    markPanel(closestStep(root.querySelector('[data-cd-record-field="title"]')), 'text');
    markPanel(closestStep(root.querySelector('[data-cd-record-size-group]')), 'size');
    markPanel(root.querySelector('.cd-checkout-step'), 'review');

    createTabs(root, preview, [
      { key: 'photo', label: 'Photo' },
      { key: 'qr', label: 'QR' },
      { key: 'text', label: 'Text' },
      { key: 'size', label: 'Size' },
      { key: 'review', label: 'Review' }
    ], root.querySelector('[data-cd-record-stage]'));
    wireTabs(root, 'photo');
  }


  function setupGlass(root) {
    if (!root || root.classList.contains('cd-mobile-wizard-ready')) return;
    var form = root.querySelector('[data-cd-glass-form]');
    var preview = root.querySelector('.cd-glass__preview-card');
    if (!form || !preview) return;

    root.classList.add('cd-mobile-wizard-ready', 'cd-mobile-wizard--glass');
    form.classList.add('cd-mobile-form');
    root.querySelectorAll('.cd-glass__side--left, .cd-glass__side--right').forEach(function (el) { el.classList.add('cd-mobile-shell'); });

    markPanel(closestStep(root.querySelector('[data-cd-glass-direct-upload]')), 'photo');
    markPanel(closestStep(root.querySelector('[data-cd-glass-type-group]')), 'photo');
    markPanel(root.querySelector('.cd-glass__adjust-under'), 'edit');
    markPanel(closestStep(root.querySelector('[data-cd-glass-size-group]')), 'size');
    markPanel(root.querySelector('.cd-checkout-step'), 'review');

    createTabs(root, preview, [
      { key: 'photo', label: 'Photo' },
      { key: 'edit', label: 'Edit' },
      { key: 'size', label: 'Size' },
      { key: 'review', label: 'Review' }
    ], root.querySelector('[data-cd-glass-stage]'));
    wireTabs(root, 'photo');
  }


  function setupCrystal(root) {
    if (!root || root.classList.contains('cd-mobile-wizard-ready')) return;
    var form = root.querySelector('[data-cd-crystal-form]');
    var preview = root.querySelector('.cd-crystal__preview-card');
    if (!form || !preview) return;

    root.classList.add('cd-mobile-wizard-ready', 'cd-mobile-wizard--crystal');
    form.classList.add('cd-mobile-form');
    root.querySelectorAll('.cd-crystal__side--left, .cd-crystal__side--right').forEach(function (el) { el.classList.add('cd-mobile-shell'); });

    markPanel(closestStep(root.querySelector('[data-cd-crystal-upload]')), 'photo');
    markPanel(root.querySelector('.cd-crystal-note'), 'photo');
    markPanel(root.querySelector('.cd-crystal__adjust-under'), 'edit');
    markPanel(closestStep(root.querySelector('[data-cd-crystal-shape-group]')), 'shape');
    markPanel(root.querySelector('.cd-checkout-step'), 'review');

    createTabs(root, preview, [
      { key: 'photo', label: 'Photo' },
      { key: 'edit', label: 'Edit' },
      { key: 'shape', label: 'Shape' },
      { key: 'review', label: 'Review' }
    ], root.querySelector('[data-cd-crystal-stage]'));
    wireTabs(root, 'photo');
  }

  function initMobileWizards() {
    document.querySelectorAll('[data-cd-puzzle-builder]').forEach(setupPuzzle);
    document.querySelectorAll('[data-cd-song-builder]').forEach(setupSong);
    document.querySelectorAll('[data-cd-record-builder]').forEach(setupRecord);
    document.querySelectorAll('[data-cd-glass-builder]').forEach(setupGlass);
    document.querySelectorAll('[data-cd-crystal-builder]').forEach(setupCrystal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobileWizards);
  else initMobileWizards();
  document.addEventListener('shopify:section:load', initMobileWizards);
})();
